(() => {
  const roots = document.querySelectorAll('[data-ccs-sticker-maker]');
  if (!roots.length) return;

  const MM_PER_INCH = 25.4;
  const PRINT_DPI = 300;
  const CUTLINE_MM = 1.5;
  const SVG_BLEED_MM = 2;
  const DISPLAY_MAX = 900;
  const MASK_MAX = 1100;

  roots.forEach(initStickerMaker);

  function initStickerMaker(root) {
    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => Array.from(root.querySelectorAll(selector));

    const el = {
      input: $('[data-artwork-input]'),
      fileLabel: $('[data-file-label]'),
      uploadWarning: $('[data-upload-warning]'),
      transparencyWarning: $('[data-transparency-warning]'),
      empty: $('[data-empty-state]'),
      stageUpload: $('[data-stage-upload]'),
      stage: $('[data-stage]'),
      canvas: $('[data-preview-canvas]'),
      removeWhite: $('[data-remove-white]'),
      width: $('[data-width-mm]'),
      sizeButtons: $$('[data-size-mm]'),
      quantityButtons: $$('[data-quantity]'),
      shapeButtons: $$('[data-shape]'),
      cornerOptions: $('[data-corner-options]'),
      cornerButtons: $$('[data-corner-radius]'),
      zoomOptions: $('[data-zoom-options]'),
      artworkZoom: $('[data-artwork-zoom]'),
      zoomValue: $('[data-zoom-value]'),
      fitArtwork: $('[data-fit-artwork]'),
      fillShape: $('[data-fill-shape]'),
      resetArtwork: $('[data-reset-artwork]'),
      dragHint: $('[data-drag-hint]'),
      recommendedPositioning: $('[data-recommended-positioning]'),
      recommendSettingsHelper: $('[data-recommend-settings-helper]'),
      recommendedSettings: $('[data-recommended-settings]'),
      recommendedSettingsStatus: $('[data-recommended-settings-status]'),
      cutlineHelp: $('[data-cutline-help]'),
      positioningWarning: $('[data-positioning-warning]'),
      positioningWarningText: $('[data-positioning-warning-text]'),
      borderEnabled: $('[data-border-enabled]'),
      borderWidth: $('[data-border-width]'),
      borderValue: $('[data-border-value]'),
      cutlineAdjustment: $('[data-cutline-adjustment]'),
      cutlineAdjustmentValue: $('[data-cutline-adjustment-value]'),
      cutlineAdjustmentNote: $('[data-cutline-adjustment-note]'),
      smoothing: $('[data-smoothing]'),
      smoothingValue: $('[data-smoothing-value]'),
      colourButtons: $$('[data-colour]'),
      sampledColoursGroup: $('[data-sampled-colours-group]'),
      sampledColours: $('[data-sampled-colours]'),
      colourPicker: $('[data-colour-picker]'),
      bleedEnabled: $('[data-bleed-enabled]'),
      showCutline: $('[data-show-cutline]'),
      qualityBox: $('[data-quality-box]'),
      dpiStatus: $('[data-dpi-status]'),
      dpiDetail: $('[data-dpi-detail]'),
      dpiMarker: $('[data-dpi-marker]'),
      qualityAdvisory: $('[data-quality-advisory]'),
      finishedDimensions: $('[data-finished-dimensions]'),
      qualityConfirm: $('[data-quality-confirm]'),
      qualityAcknowledgement: $('[data-quality-acknowledgement]'),
      artworkApproval: $('[data-artwork-approval]'),
      proof: $('[data-download-proof]'),
      print: $('[data-download-print]'),
      svg: $('[data-download-svg]'),
      add: $('[data-add-to-cart]'),
      clear: $('[data-clear-artwork]'),
      cartStatus: $('[data-cart-status]'),
      livePrice: $('[data-live-price]'),
      variantStatus: $('[data-variant-status]'),
      variantCatalog: $('[data-variant-catalog]'),
      borderControls: $$('[data-border-controls]'),
      complexWarning: $('[data-complex-warning]')
    };

    const ctx = el.canvas.getContext('2d', { alpha: true, willReadFrequently: true });

    const state = {
      sourceFile: null,
      image: null,
      sourceWidth: 0,
      sourceHeight: 0,
      sourceHasTransparency: false,
      processedCanvas: document.createElement('canvas'),
      alphaMask: null,
      maskWidth: 0,
      maskHeight: 0,
      artworkX: 0,
      artworkY: 0,
      artworkWidth: 0,
      artworkHeight: 0,
      contour: [],
      widthMm: Number(
        (el.sizeButtons.find(button => button.classList.contains('is-active')) || {}).dataset?.sizeMm
        || (el.width ? el.width.value : '')
        || 50
      ),
      shape: 'die-cut',
      quantity: Number((el.quantityButtons[0] || {}).dataset?.quantity || 1),
      selectedVariant: null,
      variantCatalog: null,
      cornerRadiusMm: 1,
      contourIsGeometric: false,
      artworkClipContour: [],
      artworkZoom: 1,
      artworkOffsetX: 0,
      artworkOffsetY: 0,
      contentBounds: null,
      contentDetection: null,
      currentDpi: 0,
      complexContour: false,
      bleedEnabled: false,
      renderScale: 1,
      isDraggingArtwork: false,
      dragLastClientX: 0,
      dragLastClientY: 0,
      borderMm: clamp(Number.isFinite(Number(el.borderWidth.value)) ? Number(el.borderWidth.value) : 2, 1, 5),
      cutlineAdjustmentMm: Number.isFinite(Number(el.cutlineAdjustment?.value)) ? Number(el.cutlineAdjustment.value) : 0,
      smoothing: Number.isFinite(Number(el.smoothing.value)) ? Number(el.smoothing.value) : 4,
      borderColour: '#ffffff',
      sampledColours: [],
      backgroundCleanupMode: 'light',
      renderTimer: 0,
      generatedPrintBlob: null,
      generatedProofBlob: null,
      dashOffset: 0,
      animationFrame: 0,
      lastAnimationTime: 0
    };

    function getAllColourButtons() {
      return Array.from(root.querySelectorAll('[data-colour]'));
    }

    function updateActiveColourSelection(activeButton = null) {
      const activeHex = normaliseHex(state.borderColour);
      getAllColourButtons().forEach(button => {
        const buttonHex = normaliseHex(button.dataset.colour || '');
        const isActive = activeButton ? button === activeButton : buttonHex === activeHex;
        button.classList.toggle('is-active', isActive);
      });
    }

    function applyBorderColour(colour, activeButton = null) {
      state.borderColour = normaliseHex(colour || '#ffffff');
      if (el.colourPicker) {
        el.colourPicker.value = state.borderColour;
      }
      updateActiveColourSelection(activeButton);
      scheduleRender();
    }

    function bindColourButton(button) {
      if (!button || button.dataset.boundClick === 'true') return;
      button.dataset.boundClick = 'true';
      button.addEventListener('click', () => {
        applyBorderColour(button.dataset.colour, button);
      });
    }

    function clearSampledColours() {
      state.sampledColours = [];
      if (el.sampledColours) el.sampledColours.innerHTML = '';
      if (el.sampledColoursGroup) el.sampledColoursGroup.hidden = true;
    }

    function renderSampledColours() {
      if (!el.sampledColours || !el.sampledColoursGroup) return;
      el.sampledColours.innerHTML = '';
      if (!state.sampledColours.length) {
        el.sampledColoursGroup.hidden = true;
        return;
      }

      state.sampledColours.forEach((hex, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'ccs-sticker-maker__swatch ccs-sticker-maker__swatch--sampled';
        button.style.setProperty('--swatch', hex);
        button.dataset.colour = hex;
        button.setAttribute('aria-label', `Artwork colour ${index + 1}`);
        button.title = `Artwork colour ${index + 1}`;
        el.sampledColours.appendChild(button);
        bindColourButton(button);
      });

      el.sampledColoursGroup.hidden = false;
      updateActiveColourSelection();
    }

    function sampleArtworkColours(imageData) {
      const smallCanvas = document.createElement('canvas');
      const smallCtx = smallCanvas.getContext('2d', { alpha: true, willReadFrequently: true });
      if (!smallCtx) return [];

      const maxDim = 64;
      const scale = Math.min(1, maxDim / Math.max(imageData.width, imageData.height));
      smallCanvas.width = Math.max(1, Math.round(imageData.width * scale));
      smallCanvas.height = Math.max(1, Math.round(imageData.height * scale));

      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = imageData.width;
      tempCanvas.height = imageData.height;
      const tempCtx = tempCanvas.getContext('2d', { alpha: true, willReadFrequently: true });
      tempCtx.putImageData(imageData, 0, 0);
      smallCtx.drawImage(tempCanvas, 0, 0, smallCanvas.width, smallCanvas.height);

      const sampled = smallCtx.getImageData(0, 0, smallCanvas.width, smallCanvas.height).data;
      const buckets = new Map();
      const quantStep = 24;

      for (let i = 0; i < sampled.length; i += 4) {
        const alpha = sampled[i + 3];
        if (alpha < 140) continue;

        const r = sampled[i];
        const g = sampled[i + 1];
        const b = sampled[i + 2];
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const avg = (r + g + b) / 3;
        const sat = max - min;

        if (avg > 242 && sat < 18) continue;

        const qr = Math.round(r / quantStep) * quantStep;
        const qg = Math.round(g / quantStep) * quantStep;
        const qb = Math.round(b / quantStep) * quantStep;
        const key = `${Math.min(255, qr)}_${Math.min(255, qg)}_${Math.min(255, qb)}`;

        let bucket = buckets.get(key);
        if (!bucket) {
          bucket = { count: 0, r: 0, g: 0, b: 0, satTotal: 0 };
          buckets.set(key, bucket);
        }

        bucket.count += 1;
        bucket.r += r;
        bucket.g += g;
        bucket.b += b;
        bucket.satTotal += sat;
      }

      const ranked = Array.from(buckets.values())
        .map(bucket => {
          const r = Math.round(bucket.r / bucket.count);
          const g = Math.round(bucket.g / bucket.count);
          const b = Math.round(bucket.b / bucket.count);
          const satAvg = bucket.satTotal / bucket.count;
          return {
            hex: rgbToHex(r, g, b),
            r,
            g,
            b,
            score: bucket.count * (1 + Math.min(0.8, satAvg / 160))
          };
        })
        .sort((a, b) => b.score - a.score);

      const selected = [];
      for (const colour of ranked) {
        const tooClose = selected.some(existing => colourDistance(existing, colour) < 56);
        if (tooClose) continue;
        selected.push(colour);
        if (selected.length >= 5) break;
      }

      return selected.map(item => item.hex);
    }

    function colourDistance(a, b) {
      const dr = a.r - b.r;
      const dg = a.g - b.g;
      const db = a.b - b.b;
      return Math.sqrt(dr * dr + dg * dg + db * db);
    }

    function rgbToHex(r, g, b) {
      return `#${[r, g, b].map(value => clamp(Math.round(value), 0, 255).toString(16).padStart(2, '0')).join('')}`;
    }

    try {
      state.variantCatalog = el.variantCatalog
        ? JSON.parse(el.variantCatalog.textContent)
        : null;
    } catch (error) {
      console.error('CCS Sticker Maker variant data could not be parsed.', error);
      state.variantCatalog = null;
    }

    // The first preset is the visual default, so the numeric field and
    // internal scale must begin with that same value.
    if (el.width) el.width.value = String(state.widthMm);
    el.sizeButtons.forEach(button => {
      button.classList.toggle(
        'is-active',
        Number(button.dataset.sizeMm) === state.widthMm
      );
    });

    if (el.stageUpload) {
      el.stageUpload.addEventListener('click', () => el.input.click());
    }

    el.input.addEventListener('change', handleFile);

    if (el.qualityAcknowledgement) {
      el.qualityAcknowledgement.addEventListener('change', updateAddButtonState);
    }

    if (el.artworkApproval) {
      el.artworkApproval.addEventListener('change', updateAddButtonState);
    }

    if (el.stage) {
      el.stage.addEventListener('pointerdown', startArtworkDrag);
      window.addEventListener('pointermove', moveArtworkDrag);
      window.addEventListener('pointerup', endArtworkDrag);
      window.addEventListener('pointercancel', endArtworkDrag);
    }
    el.removeWhite.addEventListener('change', rebuild);


    if (el.viewProcessed) {
      el.viewProcessed.addEventListener('click', () => {
            scheduleRender();
      });
    }

    el.sizeButtons.forEach(btn => btn.addEventListener('click', () => {
      state.widthMm = Number(btn.dataset.sizeMm);
      if (el.width) el.width.value = String(state.widthMm);
      el.sizeButtons.forEach(item => item.classList.toggle('is-active', item === btn));
      updateDpi();
      updateMatchedVariant();
      rebuild();
    }));

    el.quantityButtons.forEach(btn => btn.addEventListener('click', () => {
      state.quantity = Math.max(1, Number(btn.dataset.quantity) || 1);
      el.quantityButtons.forEach(item => {
        item.classList.toggle('is-active', item === btn);
      });
      updateMatchedVariant();
    }));

    el.shapeButtons.forEach(btn => btn.addEventListener('click', () => {
      state.shape = btn.dataset.shape;
      el.shapeButtons.forEach(item => item.classList.toggle('is-active', item === btn));
      updateCornerOptions();
      updateFinishedDimensions();
      rebuildContour();
      updatePositioningGuidance();
      scheduleRender();
    }));

    el.cornerButtons.forEach(btn => btn.addEventListener('click', () => {
      state.cornerRadiusMm = Number(btn.dataset.cornerRadius) || 1;
      el.cornerButtons.forEach(item => item.classList.toggle('is-active', item === btn));
      rebuildContour();
      scheduleRender();
    }));

    function updateCornerOptions() {
      if (el.cornerOptions) {
        el.cornerOptions.hidden = el.cornerOptions.dataset.featureEnabled !== 'true' || !['square', 'rectangle'].includes(state.shape);
      }
      if (el.zoomOptions) {
        el.zoomOptions.hidden = el.zoomOptions.dataset.featureEnabled !== 'true' || !['circle', 'square', 'rectangle'].includes(state.shape);
      }
      clampArtworkOffset();
      updateStageCursor();
    }

    if (el.artworkZoom) {
      el.artworkZoom.addEventListener('input', () => {
        const percent = Number(el.artworkZoom.value);
        state.artworkZoom = Number.isFinite(percent) ? percent / 100 : 1;
        clampArtworkOffset();
        if (el.zoomValue) {
          el.zoomValue.textContent = `${Math.round(state.artworkZoom * 100)}%`;
        }
        updatePositioningGuidance();
        scheduleRender();
      });
    }


    if (el.cutlineAdjustment) {
      el.cutlineAdjustment.addEventListener('input', () => {
        state.cutlineAdjustmentMm = clamp(
          Number.isFinite(Number(el.cutlineAdjustment.value))
            ? Number(el.cutlineAdjustment.value)
            : 0,
          -2,
          2
        );
        el.cutlineAdjustment.value = String(state.cutlineAdjustmentMm);
        updateCutlineAdjustmentUi();
        rebuildContour();
        scheduleRender();
      });
    }

    if (el.fitArtwork) {
      el.fitArtwork.addEventListener('click', () => { applyArtworkFit('fit'); updatePositioningGuidance(); });
    }
    if (el.fillShape) {
      el.fillShape.addEventListener('click', () => { applyArtworkFit('fill'); updatePositioningGuidance(); });
    }
    if (el.resetArtwork) {
      el.resetArtwork.addEventListener('click', () => {
        state.artworkZoom = 1;
        state.artworkOffsetX = 0;
        state.artworkOffsetY = 0;
        if (el.artworkZoom) el.artworkZoom.value = '100';
        if (el.zoomValue) el.zoomValue.textContent = '100%';
        updatePositioningGuidance();
        scheduleRender();
      });
    }

    if (el.recommendedPositioning) {
      el.recommendedPositioning.addEventListener('click', applyRecommendedPositioning);
    }

    if (el.recommendedSettings) {
      el.recommendedSettings.addEventListener('click', applyRecommendedSettings);
    }

    el.borderEnabled.addEventListener('change', () => {
      if (el.borderEnabled.checked) {
        state.borderMm = clamp(state.borderMm, 1, 5);
        el.borderWidth.value = String(state.borderMm);
        el.borderValue.textContent = `${trimNumber(state.borderMm)} mm`;
      }
      updateBorderControls();
      rebuildContour();
      scheduleRender();
    });

    el.borderWidth.addEventListener('input', () => {
      state.borderMm = clamp(
        Number.isFinite(Number(el.borderWidth.value))
          ? Number(el.borderWidth.value)
          : 2,
        1,
        5
      );
      el.borderWidth.value = String(state.borderMm);
      el.borderValue.textContent = `${trimNumber(state.borderMm)} mm`;
      rebuildContour();
      scheduleRender();
    });

    el.smoothing.addEventListener('input', () => {
      state.smoothing = Number.isFinite(Number(el.smoothing.value)) ? Number(el.smoothing.value) : 0;
      el.smoothingValue.textContent = String(state.smoothing);
      rebuildContour();
      scheduleRender();
    });

    el.colourButtons.forEach(bindColourButton);

    el.colourPicker.addEventListener('input', () => {
      applyBorderColour(el.colourPicker.value, null);
    });

    updateActiveColourSelection();

    if (el.bleedEnabled) {
      el.bleedEnabled.addEventListener('change', () => {
        state.bleedEnabled = el.bleedEnabled.checked;
        scheduleRender();
      });
    }

    el.showCutline.addEventListener('change', () => {
      if (el.cutlineHelp) el.cutlineHelp.hidden = !el.showCutline.checked;
      scheduleRender();
    });
    if (el.proof) el.proof.addEventListener('click', downloadProof);
    if (el.print) el.print.addEventListener('click', downloadPrint);
    if (el.svg) el.svg.addEventListener('click', downloadSvg);
    if (el.add) el.add.addEventListener('click', addToCart);
    el.clear.addEventListener('click', clearArtwork);
    window.addEventListener('resize', scheduleRender);

    function animateCutLine(timestamp) {
      // Synchronise state with the actual controls, including valid zero values,
    // before the first artwork upload is processed.
    state.bleedEnabled = false;

    state.borderMm = clamp(
      Number.isFinite(Number(el.borderWidth.value))
        ? Number(el.borderWidth.value)
        : 2,
      1,
      5
    );
    el.borderWidth.value = String(state.borderMm);
    state.smoothing = Number.isFinite(Number(el.smoothing.value))
      ? Number(el.smoothing.value)
      : 0;
    state.cutlineAdjustmentMm = Number.isFinite(Number(el.cutlineAdjustment?.value))
      ? clamp(Number(el.cutlineAdjustment.value), -2, 2)
      : 0;
    el.borderValue.textContent = `${trimNumber(state.borderMm)} mm`;
    el.smoothingValue.textContent = String(state.smoothing);
    updateCutlineAdjustmentUi();

    updateCornerOptions();
    updateStageCursor();
    updateBorderControls();
    updateCutlineAdjustmentUi();
    updateMatchedVariant();

    state.animationFrame = requestAnimationFrame(animateCutLine);
      if (!state.image || !el.showCutline.checked) return;
      if (timestamp - state.lastAnimationTime < 42) return;
      state.lastAnimationTime = timestamp;
      state.dashOffset = (state.dashOffset + 1.4) % 1000;
      render();
    }

    state.animationFrame = requestAnimationFrame(animateCutLine);


    function updateCutlineAdjustmentUi() {
      if (el.cutlineAdjustmentValue) {
        const value = state.cutlineAdjustmentMm;
        const sign = value > 0 ? '+' : '';
        el.cutlineAdjustmentValue.textContent = `${sign}${trimNumber(value)} mm`;
      }
      if (el.cutlineAdjustmentNote) {
        const show = state.cutlineAdjustmentMm < 0;
        el.cutlineAdjustmentNote.hidden = !show;
        el.cutlineAdjustmentNote.style.display = show ? 'block' : 'none';
      }
    }

    function getRequestedCutlineOffsetMm() {
      return (el.borderEnabled.checked ? state.borderMm : 0) + state.cutlineAdjustmentMm;
    }

    function getEffectiveVisibleSizeMm(requestedCutlineOffsetMm) {
      return Math.max(1, state.widthMm - requestedCutlineOffsetMm * 2);
    }

    function updateBorderControls() {
      const disabled = !el.borderEnabled.checked;
      el.borderControls.forEach(group => {
        group.classList.toggle('is-disabled', disabled);
        group.querySelectorAll('input, button').forEach(control => {
          control.disabled = disabled;
        });
      });
    }

    function getOpaqueMaskBounds(mask, w, h, fallback = null) {
      let minX = Infinity;
      let minY = Infinity;
      let maxX = -Infinity;
      let maxY = -Infinity;

      for (let y = 0; y < h; y++) {
        const row = y * w;
        for (let x = 0; x < w; x++) {
          if (!mask[row + x]) continue;
          if (x < minX) minX = x;
          if (y < minY) minY = y;
          if (x > maxX) maxX = x;
          if (y > maxY) maxY = y;
        }
      }

      if (!Number.isFinite(minX)) {
        return fallback || {
          x: state.artworkX,
          y: state.artworkY,
          width: state.artworkWidth,
          height: state.artworkHeight
        };
      }

      return {
        x: minX,
        y: minY,
        width: Math.max(1, maxX - minX + 1),
        height: Math.max(1, maxY - minY + 1)
      };
    }

    function getShapeBounds() {
      if (!state.artworkClipContour || !state.artworkClipContour.length) {
        return {
          width: state.artworkWidth,
          height: state.artworkHeight
        };
      }
      const bounds = contourBounds(state.artworkClipContour);
      return {
        width: Math.max(1, bounds.maxX - bounds.minX),
        height: Math.max(1, bounds.maxY - bounds.minY)
      };
    }

    function applyArtworkFit(mode) {
      if (!canRepositionArtwork()) return;
      const shape = getShapeBounds();
      const scaleX = shape.width / Math.max(1, state.artworkWidth);
      const scaleY = shape.height / Math.max(1, state.artworkHeight);
      const nextZoom = mode === 'fill'
        ? Math.max(scaleX, scaleY)
        : Math.min(scaleX, scaleY);

      state.artworkZoom = clamp(nextZoom, 0.5, 2);
      state.artworkOffsetX = 0;
      state.artworkOffsetY = 0;
      if (el.artworkZoom) el.artworkZoom.value = String(Math.round(state.artworkZoom * 100));
      if (el.zoomValue) el.zoomValue.textContent = `${Math.round(state.artworkZoom * 100)}%`;
      clampArtworkOffset();
      scheduleRender();
    }


    function updateArtworkZoomUi() {
      if (el.artworkZoom) el.artworkZoom.value = String(Math.round(state.artworkZoom * 100));
      if (el.zoomValue) el.zoomValue.textContent = `${Math.round(state.artworkZoom * 100)}%`;
    }

    function showRecommendedSettingsHelper() {
      if (!el.recommendSettingsHelper) return;
      el.recommendSettingsHelper.hidden = false;
      el.recommendSettingsHelper.classList.remove('is-attention');
      void el.recommendSettingsHelper.offsetWidth;
      el.recommendSettingsHelper.classList.add('is-attention');
      window.setTimeout(() => {
        if (el.recommendSettingsHelper) el.recommendSettingsHelper.classList.remove('is-attention');
      }, 1800);
    }

    function shouldRecommendBackgroundCleanup() {
      if (!state.image || !state.processedCanvas || !state.artworkWidth || !state.artworkHeight) return false;

      const pctx = state.processedCanvas.getContext('2d', { alpha: true, willReadFrequently: true });
      if (!pctx) return false;

      const imageData = pctx.getImageData(0, 0, state.processedCanvas.width, state.processedCanvas.height);
      const { data, width } = imageData;
      const x0 = state.artworkX;
      const y0 = state.artworkY;
      const w = state.artworkWidth;
      const h = state.artworkHeight;
      const step = Math.max(1, Math.floor(Math.max(w, h) / 80));
      const samples = [];

      function add(x, y) {
        const offset = (y * width + x) * 4;
        if (data[offset + 3] < 220) return;
        samples.push({ r: data[offset], g: data[offset + 1], b: data[offset + 2] });
      }

      for (let x = x0; x < x0 + w; x += step) {
        add(x, y0);
        add(x, y0 + h - 1);
      }
      for (let y = y0; y < y0 + h; y += step) {
        add(x0, y);
        add(x0 + w - 1, y);
      }

      if (samples.length < 8) return false;

      const sortedR = samples.map(v => v.r).sort((a,b) => a-b);
      const sortedG = samples.map(v => v.g).sort((a,b) => a-b);
      const sortedB = samples.map(v => v.b).sort((a,b) => a-b);
      const mid = Math.floor(samples.length / 2);
      const bg = { r: sortedR[mid], g: sortedG[mid], b: sortedB[mid] };
      const bgMax = Math.max(bg.r, bg.g, bg.b);
      const bgMin = Math.min(bg.r, bg.g, bg.b);
      const bgSpread = bgMax - bgMin;
      const bgAvg = (bg.r + bg.g + bg.b) / 3;

      // Only auto-clean the two background families the cleanup tool is built
      // for: pale/white AI-style backgrounds and black/dark neutral canvases.
      const lightCandidate = bgAvg >= 185 && bgSpread <= 65;
      const darkCandidate = bgAvg <= 92 && bgSpread <= 70;
      if (!lightCandidate && !darkCandidate) return false;

      let matching = 0;
      for (const sample of samples) {
        const dr = sample.r - bg.r;
        const dg = sample.g - bg.g;
        const db = sample.b - bg.b;
        const distance = Math.sqrt(dr*dr + dg*dg + db*db);
        if (distance <= (lightCandidate ? 62 : 54)) matching++;
      }

      // Require most of the actual image perimeter to look like one background
      // colour. This avoids switching full photographs to die-cut by mistake.
      return matching / samples.length >= 0.68;
    }

    function chooseRecommendedShape() {
      if (!state.image) return 'die-cut';
      if (state.contentDetection === 'alpha') return 'die-cut';
      const ratio = state.artworkWidth / Math.max(1, state.artworkHeight);
      return ratio >= 0.88 && ratio <= 1.14 ? 'square' : 'rectangle';
    }

    function selectShape(shape) {
      state.shape = shape;
      el.shapeButtons.forEach(button => {
        button.classList.toggle('is-active', button.dataset.shape === shape);
      });
      updateCornerOptions();
      updateFinishedDimensions();
      rebuildContour();
    }

    async function applyRecommendedSettings() {
      if (!state.image) return;

      // Decide whether background cleanup is appropriate before choosing a
      // shape. Once a removable white/light-grey or black outer background is
      // removed, the resulting transparency should naturally recommend Die Cut.
      const recommendCleanup = shouldRecommendBackgroundCleanup();
      if (recommendCleanup && el.removeWhite && !el.removeWhite.checked) {
        el.removeWhite.checked = true;
        await rebuild();
      }

      const recommendedShape = chooseRecommendedShape();
      selectShape(recommendedShape);

      if (el.borderEnabled) el.borderEnabled.checked = true;
      state.borderMm = 2;
      if (el.borderWidth) el.borderWidth.value = '2';
      if (el.borderValue) el.borderValue.textContent = '2 mm';
      applyBorderColour('#ffffff');

      state.cutlineAdjustmentMm = 0;
      if (el.cutlineAdjustment) el.cutlineAdjustment.value = '0';
      updateCutlineAdjustmentUi();

      state.smoothing = 4;
      if (el.smoothing) el.smoothing.value = '4';
      if (el.smoothingValue) el.smoothingValue.textContent = '4';

      if (recommendedShape === 'die-cut') {
        state.artworkZoom = 1;
        state.artworkOffsetX = 0;
        state.artworkOffsetY = 0;
        updateArtworkZoomUi();
      } else {
        applyRecommendedPositioning();
      }

      rebuildContour();
      updatePositioningGuidance();
      scheduleRender();

      if (el.recommendedSettingsStatus) {
        const label = recommendedShape === 'die-cut'
          ? 'Die-cut'
          : recommendedShape.charAt(0).toUpperCase() + recommendedShape.slice(1);
        el.recommendedSettingsStatus.textContent = recommendCleanup
          ? `Recommended settings applied · Background cleaned · ${label}`
          : `Recommended settings applied · ${label}`;
        el.recommendedSettingsStatus.hidden = false;
      }
      if (el.recommendSettingsHelper) el.recommendSettingsHelper.classList.remove('is-attention');
    }

    function applyRecommendedPositioning() {
      if (!canRepositionArtwork() || !state.contentBounds) return;

      const shapeBounds = contourBounds(state.artworkClipContour);
      const content = state.contentBounds;
      const shapeWidth = Math.max(1, shapeBounds.maxX - shapeBounds.minX);
      const shapeHeight = Math.max(1, shapeBounds.maxY - shapeBounds.minY);
      const contentWidth = Math.max(1, content.width);
      const contentHeight = Math.max(1, content.height);

      // Circles need a little more breathing room at the corners than square
      // and rectangular stickers. These values deliberately avoid tight crops.
      const usableFraction = state.shape === 'circle' ? 0.72 : 0.82;
      const targetWidth = shapeWidth * usableFraction;
      const targetHeight = shapeHeight * usableFraction;
      const nextZoom = Math.min(targetWidth / contentWidth, targetHeight / contentHeight);

      state.artworkZoom = clamp(nextZoom, 0.5, 2);

      const artworkCentreX = state.artworkX + state.artworkWidth / 2;
      const artworkCentreY = state.artworkY + state.artworkHeight / 2;
      const contentCentreX = content.x + content.width / 2;
      const contentCentreY = content.y + content.height / 2;
      const shapeCentreX = (shapeBounds.minX + shapeBounds.maxX) / 2;
      const shapeCentreY = (shapeBounds.minY + shapeBounds.maxY) / 2;

      state.artworkOffsetX =
        shapeCentreX - artworkCentreX - state.artworkZoom * (contentCentreX - artworkCentreX);
      state.artworkOffsetY =
        shapeCentreY - artworkCentreY - state.artworkZoom * (contentCentreY - artworkCentreY);

      clampArtworkOffset();
      updateArtworkZoomUi();
      updatePositioningGuidance();
      scheduleRender();
    }

    function getTransformedContentBounds() {
      if (!state.contentBounds) return null;
      const content = state.contentBounds;
      const artworkCentreX = state.artworkX + state.artworkWidth / 2;
      const artworkCentreY = state.artworkY + state.artworkHeight / 2;
      const zoom = state.artworkZoom;

      const left = artworkCentreX + state.artworkOffsetX + zoom * (content.x - artworkCentreX);
      const top = artworkCentreY + state.artworkOffsetY + zoom * (content.y - artworkCentreY);
      const right = artworkCentreX + state.artworkOffsetX + zoom * (content.x + content.width - artworkCentreX);
      const bottom = artworkCentreY + state.artworkOffsetY + zoom * (content.y + content.height - artworkCentreY);

      return { left, top, right, bottom };
    }

    function updatePositioningGuidance() {
      if (!el.positioningWarning) return;

      const shouldCheck = canRepositionArtwork() && Boolean(state.contentBounds);
      if (!shouldCheck) {
        el.positioningWarning.hidden = true;
        return;
      }

      const shapeBounds = contourBounds(state.artworkClipContour);
      const transformed = getTransformedContentBounds();
      if (!transformed) {
        el.positioningWarning.hidden = true;
        return;
      }

      const shapeWidth = Math.max(1, shapeBounds.maxX - shapeBounds.minX);
      const shapeHeight = Math.max(1, shapeBounds.maxY - shapeBounds.minY);
      const leftMargin = transformed.left - shapeBounds.minX;
      const rightMargin = shapeBounds.maxX - transformed.right;
      const topMargin = transformed.top - shapeBounds.minY;
      const bottomMargin = shapeBounds.maxY - transformed.bottom;

      const horizontalImbalance = Math.abs(leftMargin - rightMargin) / shapeWidth;
      const verticalImbalance = Math.abs(topMargin - bottomMargin) / shapeHeight;
      const cropped = Math.min(leftMargin, rightMargin, topMargin, bottomMargin) < -2;
      const offCentre = horizontalImbalance > 0.14 || verticalImbalance > 0.14;

      el.positioningWarning.hidden = !(cropped || offCentre);
      if (el.positioningWarningText) {
        el.positioningWarningText.textContent = cropped
          ? 'Part of the main artwork may be cropped by the selected shape. Reposition it or use our recommended positioning.'
          : 'The main artwork appears off-centre inside the selected shape. You can drag it in the preview or use our recommended positioning.';
      }
    }

    function analyseArtworkContentBounds(imageData) {
      const { data } = imageData;
      const x0 = state.artworkX;
      const y0 = state.artworkY;
      const width = state.artworkWidth;
      const height = state.artworkHeight;
      if (!width || !height) return null;

      const sampleStep = Math.max(1, Math.floor(Math.max(width, height) / 180));
      let transparentSamples = 0;
      let totalSamples = 0;

      for (let y = y0; y < y0 + height; y += sampleStep) {
        for (let x = x0; x < x0 + width; x += sampleStep) {
          const offset = (y * imageData.width + x) * 4;
          totalSamples++;
          if (data[offset + 3] < 40) transparentSamples++;
        }
      }

      const hasTransparency = totalSamples > 0 && transparentSamples / totalSamples > 0.01;

      // For opaque artwork, use the four actual artwork corners as the likely
      // background colour. This is aimed at logos supplied on a flat canvas.
      const cornerRadius = Math.max(1, Math.round(Math.min(width, height) * 0.025));
      const cornerColours = [];
      const cornerPoints = [
        [x0, y0],
        [x0 + width - 1, y0],
        [x0, y0 + height - 1],
        [x0 + width - 1, y0 + height - 1]
      ];

      for (const [cx, cy] of cornerPoints) {
        let sr = 0, sg = 0, sb = 0, count = 0;
        for (let yy = Math.max(y0, cy - cornerRadius); yy <= Math.min(y0 + height - 1, cy + cornerRadius); yy += sampleStep) {
          for (let xx = Math.max(x0, cx - cornerRadius); xx <= Math.min(x0 + width - 1, cx + cornerRadius); xx += sampleStep) {
            const offset = (yy * imageData.width + xx) * 4;
            if (data[offset + 3] < 200) continue;
            sr += data[offset]; sg += data[offset + 1]; sb += data[offset + 2]; count++;
          }
        }
        if (count) cornerColours.push({ r: sr / count, g: sg / count, b: sb / count });
      }

      let background = null;
      if (cornerColours.length) {
        background = {
          r: cornerColours.reduce((sum, c) => sum + c.r, 0) / cornerColours.length,
          g: cornerColours.reduce((sum, c) => sum + c.g, 0) / cornerColours.length,
          b: cornerColours.reduce((sum, c) => sum + c.b, 0) / cornerColours.length
        };
      }

      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      let contentCount = 0;
      let sampledCount = 0;

      for (let y = y0; y < y0 + height; y += sampleStep) {
        for (let x = x0; x < x0 + width; x += sampleStep) {
          const offset = (y * imageData.width + x) * 4;
          const a = data[offset + 3];
          let isContent = false;

          if (hasTransparency) {
            isContent = a >= 40;
          } else if (background) {
            const dr = data[offset] - background.r;
            const dg = data[offset + 1] - background.g;
            const db = data[offset + 2] - background.b;
            const distance = Math.sqrt(dr * dr + dg * dg + db * db);
            isContent = a >= 80 && distance >= 42;
          }

          sampledCount++;
          if (!isContent) continue;
          contentCount++;
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x);
          maxY = Math.max(maxY, y);
        }
      }

      if (!contentCount || contentCount / Math.max(1, sampledCount) < 0.01 || !Number.isFinite(minX)) {
        return null;
      }

      const grow = Math.max(2, sampleStep * 2);
      minX = Math.max(x0, minX - grow);
      minY = Math.max(y0, minY - grow);
      maxX = Math.min(x0 + width, maxX + grow);
      maxY = Math.min(y0 + height, maxY + grow);

      return {
        x: minX,
        y: minY,
        width: Math.max(1, maxX - minX),
        height: Math.max(1, maxY - minY),
        mode: hasTransparency ? 'alpha' : 'background'
      };
    }

    function updateQualityAcknowledgement() {
      const needsConfirmation = Boolean(
        state.image &&
        state.currentDpi > 0 &&
        state.currentDpi < 150
      );

      if (el.qualityConfirm) {
        el.qualityConfirm.hidden = !needsConfirmation;
        el.qualityConfirm.style.display = needsConfirmation ? 'flex' : 'none';
      }

      if (!needsConfirmation && el.qualityAcknowledgement) {
        el.qualityAcknowledgement.checked = false;
      }

      updateAddButtonState();
    }

    function updateAddButtonState() {
      if (!el.add) return;
      const lowQualityBlocked =
        state.currentDpi > 0 &&
        state.currentDpi < 150 &&
        el.qualityAcknowledgement &&
        !el.qualityAcknowledgement.checked;

      const approvalBlocked =
        el.artworkApproval &&
        !el.artworkApproval.checked;

      el.add.disabled =
        !state.image ||
        !state.selectedVariant ||
        lowQualityBlocked ||
        approvalBlocked;
    }

    function canRepositionArtwork() {
      return Boolean(
        state.image &&
        ['circle', 'square', 'rectangle'].includes(state.shape) &&
        state.artworkClipContour &&
        state.artworkClipContour.length
      );
    }

    function getArtworkPanBounds() {
      if (!canRepositionArtwork()) {
        return { maxX: 0, maxY: 0 };
      }

      const clipBounds = contourBounds(state.artworkClipContour);
      const clipWidth = Math.max(1, clipBounds.maxX - clipBounds.minX);
      const clipHeight = Math.max(1, clipBounds.maxY - clipBounds.minY);
      const scaledArtworkWidth = state.artworkWidth * state.artworkZoom;
      const scaledArtworkHeight = state.artworkHeight * state.artworkZoom;

      // Always allow deliberate repositioning, even when the artwork is
      // smaller than the shape. The movement limit remains tied to the shape
      // size so customers cannot lose the artwork completely off-canvas.
      return {
        maxX: Math.max(
          clipWidth * 0.45,
          Math.abs(scaledArtworkWidth - clipWidth) / 2
        ),
        maxY: Math.max(
          clipHeight * 0.45,
          Math.abs(scaledArtworkHeight - clipHeight) / 2
        )
      };
    }

    function clampArtworkOffset() {
      const bounds = getArtworkPanBounds();
      state.artworkOffsetX = clamp(state.artworkOffsetX, -bounds.maxX, bounds.maxX);
      state.artworkOffsetY = clamp(state.artworkOffsetY, -bounds.maxY, bounds.maxY);
    }

    function updateStageCursor() {
      if (!el.stage) return;
      if (canRepositionArtwork()) {
        el.stage.style.cursor = state.isDraggingArtwork ? 'grabbing' : 'grab';
      } else {
        el.stage.style.cursor = '';
      }
    }

    function startArtworkDrag(event) {
      if (!canRepositionArtwork()) return;
      state.isDraggingArtwork = true;
      state.dragLastClientX = event.clientX;
      state.dragLastClientY = event.clientY;
      updateStageCursor();
      event.preventDefault();
    }

    function moveArtworkDrag(event) {
      if (!state.isDraggingArtwork || !canRepositionArtwork()) return;
      const renderScale = state.renderScale || 1;
      state.artworkOffsetX += (event.clientX - state.dragLastClientX) / renderScale;
      state.artworkOffsetY += (event.clientY - state.dragLastClientY) / renderScale;
      state.dragLastClientX = event.clientX;
      state.dragLastClientY = event.clientY;
      clampArtworkOffset();
      updatePositioningGuidance();
      scheduleRender();
      event.preventDefault();
    }

    function endArtworkDrag() {
      if (!state.isDraggingArtwork) return;
      state.isDraggingArtwork = false;
      updateStageCursor();
    }

    function showUploadWarning(message) {
      if (el.uploadWarning) {
        el.uploadWarning.textContent = message;
        el.uploadWarning.hidden = false;
      }
      setStatus(message, true);
    }

    function clearUploadWarning() {
      if (el.uploadWarning) {
        el.uploadWarning.textContent = '';
        el.uploadWarning.hidden = true;
      }
    }

    function artworkHasTransparency(imageData, bounds) {
      const startX = Math.max(0, Math.floor(bounds.x));
      const startY = Math.max(0, Math.floor(bounds.y));
      const endX = Math.min(imageData.width, Math.ceil(bounds.x + bounds.width));
      const endY = Math.min(imageData.height, Math.ceil(bounds.y + bounds.height));
      let transparentPixels = 0;
      let sampledPixels = 0;

      for (let y = startY; y < endY; y++) {
        for (let x = startX; x < endX; x++) {
          sampledPixels++;
          if (imageData.data[(y * imageData.width + x) * 4 + 3] < 250) {
            transparentPixels++;
          }
        }
      }

      return transparentPixels >= 10 && transparentPixels / Math.max(1, sampledPixels) >= 0.001;
    }

    function updateTransparencyWarning() {
      if (!el.transparencyWarning) return;
      el.transparencyWarning.hidden = !state.sourceHasTransparency;
    }

    async function handleFile(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      clearUploadWarning();

      const maxFileSize = 10 * 1024 * 1024;
      if (file.size > maxFileSize) {
        const fileSizeMb = (file.size / (1024 * 1024)).toFixed(1);
        showUploadWarning(
          `Artwork is too large (${fileSizeMb} MB). The maximum upload size is 10 MB. Please reduce the file size and upload it again.`
        );
        el.input.value = '';
        return;
      }

      if (!/image\/(png|jpeg|webp|svg\+xml)/.test(file.type) && !/\.(png|jpe?g|webp|svg)$/i.test(file.name)) {
        showUploadWarning('Please upload a PNG, JPG, WebP or SVG file.');
        el.input.value = '';
        return;
      }

      try {
        setBusy(true);
        const image = await fileToImage(file);
        state.sourceFile = file;
        state.image = image;
        state.sourceWidth = image.naturalWidth || image.width;
        state.sourceHeight = image.naturalHeight || image.height;
        state.artworkOffsetX = 0;
        state.artworkOffsetY = 0;
        el.fileLabel.textContent = file.name;
        el.empty.hidden = true;
        await rebuild();
        setEnabled(true);
        showRecommendedSettingsHelper();
        if (el.recommendedSettingsStatus) el.recommendedSettingsStatus.hidden = true;
        clearUploadWarning();
        setStatus('');
      } catch (error) {
        console.error(error);
        setStatus('That artwork could not be opened. Try exporting it as a PNG.', true);
        clearArtwork();
      } finally {
        setBusy(false);
      }
    }

    async function rebuild() {
      if (!state.image) return;

      const scale = Math.min(1, MASK_MAX / Math.max(state.sourceWidth, state.sourceHeight));
      const artworkW = Math.max(1, Math.round(state.sourceWidth * scale));
      const artworkH = Math.max(1, Math.round(state.sourceHeight * scale));

      // Keep enough transparent working space around the artwork for the
      // maximum border and bleed. This prevents clipping and keeps the
      // finished sticker visually centred.
      const maxOutsideMm = 12;
      const artworkMmPerPixel = state.widthMm / Math.max(1, artworkW);
      const pad = Math.max(18, Math.ceil(maxOutsideMm / artworkMmPerPixel));

      const w = artworkW + pad * 2;
      const h = artworkH + pad * 2;

      state.processedCanvas.width = w;
      state.processedCanvas.height = h;
      state.artworkX = pad;
      state.artworkY = pad;
      state.artworkWidth = artworkW;
      state.artworkHeight = artworkH;

      const pctx = state.processedCanvas.getContext('2d', { alpha: true, willReadFrequently: true });
      pctx.clearRect(0, 0, w, h);
      pctx.drawImage(state.image, pad, pad, artworkW, artworkH);

      const imageData = pctx.getImageData(0, 0, w, h);
      const data = imageData.data;
      const removeWhite = el.removeWhite.checked;

      state.sourceHasTransparency = artworkHasTransparency(imageData, {
        x: state.artworkX,
        y: state.artworkY,
        width: state.artworkWidth,
        height: state.artworkHeight
      });
      updateTransparencyWarning();

      for (let i = 0; i < data.length; i += 4) {
        const alpha = data[i + 3];

        // Ignore extremely faint alpha noise around otherwise transparent PNGs.
        if (alpha < 10) {
          data[i + 3] = 0;
        }
      }

      if (removeWhite) {
        state.backgroundCleanupMode = cleanConnectedArtworkBackground(
          imageData,
          {
            x: state.artworkX,
            y: state.artworkY,
            width: state.artworkWidth,
            height: state.artworkHeight
          }
        );
        lightweightEdgeCleanup(imageData);
      }

      state.contentBounds = analyseArtworkContentBounds(imageData);
      state.contentDetection = state.contentBounds ? state.contentBounds.mode : null;
      state.sampledColours = sampleArtworkColours(imageData);
      renderSampledColours();

      pctx.putImageData(imageData, 0, 0);
      state.maskWidth = w;
      state.maskHeight = h;
      state.alphaMask = makeAlphaMask(imageData, 18);
      rebuildContour();
      updateDpi();
      updatePositioningGuidance();
      scheduleRender();
    }


    function isNearWhiteOrLightBackgroundPixel(data, offset) {
      const a = data[offset + 3];
      if (a <= 8) return true;

      const r = data[offset];
      const g = data[offset + 1];
      const b = data[offset + 2];

      const max = Math.max(r, g, b);
      const min = Math.min(r, g, b);
      const spread = max - min;
      const avg = (r + g + b) / 3;

      // Pure and near-white background
      if (avg >= 244 && spread <= 28) return true;

      // Soft white glow / pale AI shadow
      if (avg >= 232 && spread <= 24) return true;

      // Light neutral fringe
      if (avg >= 220 && spread <= 18) return true;

      // Semi-transparent light halo pixels
      if (a < 110 && avg >= 180 && spread <= 26) return true;

      return false;
    }

    function getEdgeBackgroundSample(imageData, bounds = null) {
      const { width, height, data } = imageData;
      const samples = [];

      function addSample(x, y) {
        if (x < 0 || y < 0 || x >= width || y >= height) return;
        const offset = (y * width + x) * 4;
        if (data[offset + 3] <= 24) return;
        samples.push([
          data[offset],
          data[offset + 1],
          data[offset + 2]
        ]);
      }

      let left = 0;
      let top = 0;
      let right = width - 1;
      let bottom = height - 1;

      if (bounds) {
        left = Math.max(0, Math.round(bounds.x));
        top = Math.max(0, Math.round(bounds.y));
        right = Math.min(width - 1, Math.round(bounds.x + bounds.width - 1));
        bottom = Math.min(height - 1, Math.round(bounds.y + bounds.height - 1));
      }

      const sampleWidth = Math.max(1, right - left + 1);
      const sampleHeight = Math.max(1, bottom - top + 1);
      const stepX = Math.max(1, Math.floor(sampleWidth / 64));
      const stepY = Math.max(1, Math.floor(sampleHeight / 64));
      const edgeDepthX = Math.max(1, Math.min(3, Math.round(sampleWidth * 0.006)));
      const edgeDepthY = Math.max(1, Math.min(3, Math.round(sampleHeight * 0.006)));

      for (let x = left; x <= right; x += stepX) {
        for (let y = top; y < Math.min(bottom + 1, top + edgeDepthY); y++) addSample(x, y);
        for (let y = Math.max(top, bottom - edgeDepthY + 1); y <= bottom; y++) addSample(x, y);
      }

      for (let y = top; y <= bottom; y += stepY) {
        for (let x = left; x < Math.min(right + 1, left + edgeDepthX); x++) addSample(x, y);
        for (let x = Math.max(left, right - edgeDepthX + 1); x <= right; x++) addSample(x, y);
      }

      if (!samples.length) {
        return { r: 255, g: 255, b: 255, hasSamples: false };
      }

      const reds = samples.map(sample => sample[0]).sort((a, b) => a - b);
      const greens = samples.map(sample => sample[1]).sort((a, b) => a - b);
      const blues = samples.map(sample => sample[2]).sort((a, b) => a - b);
      const middle = Math.floor(samples.length / 2);

      return {
        r: reds[middle],
        g: greens[middle],
        b: blues[middle],
        hasSamples: true
      };
    }

    function cleanConnectedArtworkBackground(imageData, artworkBounds = null, forcedMode = null) {
      const background = getEdgeBackgroundSample(imageData, artworkBounds);
      const max = Math.max(background.r, background.g, background.b);
      const min = Math.min(background.r, background.g, background.b);
      const spread = max - min;
      const avg = (background.r + background.g + background.b) / 3;

      // Detect from the uploaded image edge, not from the transparent working
      // padding. A forced mode is used for high-resolution exports so the
      // preview and downloaded file always receive identical cleanup.
      const detectedMode = background.hasSamples && avg <= 82 && spread <= 56
        ? 'dark'
        : 'light';
      const mode = forcedMode || detectedMode;

      if (mode === 'dark') {
        removeConnectedDarkBackground(imageData, background);
      } else {
        removeConnectedLightBackground(imageData);
      }

      return mode;
    }

    function removeConnectedDarkBackground(imageData, background) {
      const { width, height, data } = imageData;
      const total = width * height;
      const visited = new Uint8Array(total);
      const queue = new Int32Array(total);

      function posIndex(x, y) {
        return y * width + x;
      }

      function colourDistance(r1, g1, b1, r2, g2, b2) {
        const dr = r1 - r2;
        const dg = g1 - g2;
        const db = b1 - b2;
        return Math.sqrt(dr * dr + dg * dg + db * db);
      }

      function isBackgroundCandidate(offset) {
        const a = data[offset + 3];
        if (a <= 8) return true;

        const r = data[offset];
        const g = data[offset + 1];
        const b = data[offset + 2];
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const spread = max - min;
        const avg = (r + g + b) / 3;
        const distance = colourDistance(
          r, g, b,
          background.r, background.g, background.b
        );

        // Solid black or near-black background.
        if (avg <= 26 && spread <= 30) return true;

        // Pixels close to the sampled outer background, including mild JPEG
        // noise and dark antialiasing. Only edge-connected pixels can be
        // removed, so internal black outlines remain untouched.
        if (distance <= 48 && avg <= 96 && spread <= 58) return true;

        // Semi-transparent dark fringe around artwork exported over black.
        if (a < 190 && avg <= 92 && spread <= 64) return true;

        return false;
      }

      function push(x, y, tailRef) {
        if (x < 0 || y < 0 || x >= width || y >= height) return tailRef;
        const p = posIndex(x, y);
        if (visited[p]) return tailRef;
        if (!isBackgroundCandidate(p * 4)) return tailRef;
        visited[p] = 1;
        queue[tailRef] = p;
        return tailRef + 1;
      }

      let head = 0;
      let tail = 0;

      for (let x = 0; x < width; x++) {
        tail = push(x, 0, tail);
        tail = push(x, height - 1, tail);
      }
      for (let y = 0; y < height; y++) {
        tail = push(0, y, tail);
        tail = push(width - 1, y, tail);
      }

      while (head < tail) {
        const p = queue[head++];
        const x = p % width;
        const y = Math.floor(p / width);
        tail = push(x + 1, y, tail);
        tail = push(x - 1, y, tail);
        tail = push(x, y + 1, tail);
        tail = push(x, y - 1, tail);
        tail = push(x + 1, y + 1, tail);
        tail = push(x - 1, y - 1, tail);
        tail = push(x + 1, y - 1, tail);
        tail = push(x - 1, y + 1, tail);
      }

      for (let p = 0; p < total; p++) {
        if (visited[p]) data[p * 4 + 3] = 0;
      }

      trimDarkBackgroundFringe(imageData, background);
    }

    function trimDarkBackgroundFringe(imageData, background) {
      const { width, height, data } = imageData;
      const total = width * height;

      function colourDistance(r1, g1, b1, r2, g2, b2) {
        const dr = r1 - r2;
        const dg = g1 - g2;
        const db = b1 - b2;
        return Math.sqrt(dr * dr + dg * dg + db * db);
      }

      // Only inspect the one or two pixel layers now touching transparency.
      // This removes dark JPEG/WebP antialias residue left by a black canvas
      // without scanning or altering internal black details.
      for (let pass = 0; pass < 3; pass++) {
        const alphaCopy = new Uint8Array(total);
        for (let p = 0; p < total; p++) alphaCopy[p] = data[p * 4 + 3];
        let changed = false;

        for (let y = 1; y < height - 1; y++) {
          for (let x = 1; x < width - 1; x++) {
            const p = y * width + x;
            const a = alphaCopy[p];
            if (a === 0) continue;

            const neighbours = [
              p - 1, p + 1, p - width, p + width,
              p - width - 1, p - width + 1,
              p + width - 1, p + width + 1
            ];

            let transparentNeighbours = 0;
            for (const neighbour of neighbours) {
              if (alphaCopy[neighbour] === 0) transparentNeighbours++;
            }
            if (transparentNeighbours < 2) continue;

            const offset = p * 4;
            const r = data[offset];
            const g = data[offset + 1];
            const b = data[offset + 2];
            const max = Math.max(r, g, b);
            const min = Math.min(r, g, b);
            const spread = max - min;
            const avg = (r + g + b) / 3;
            const distance = colourDistance(
              r, g, b,
              background.r, background.g, background.b
            );

            const closeToDarkBackground = distance <= 108 && avg <= 172 && spread <= 92;
            const translucentDarkEdge = a < 244 && avg <= 170 && spread <= 96;
            const neutralGreyResidue = avg <= 178 && spread <= 42;
            const finalOuterGrey =
              pass === 2 &&
              transparentNeighbours >= 3 &&
              avg <= 196 &&
              spread <= 48;

            if (
              closeToDarkBackground ||
              translucentDarkEdge ||
              neutralGreyResidue ||
              finalOuterGrey
            ) {
              data[offset + 3] = 0;
              changed = true;
            }
          }
        }

        if (!changed) break;
      }
    }

    function removeConnectedLightBackground(imageData) {
      const { width, height, data } = imageData;
      const total = width * height;
      const visited = new Uint8Array(total);
      const queue = new Int32Array(total);
      const background = getEdgeBackgroundSample(imageData);

      function posIndex(x, y) {
        return y * width + x;
      }

      function colourDistance(r1, g1, b1, r2, g2, b2) {
        const dr = r1 - r2;
        const dg = g1 - g2;
        const db = b1 - b2;
        return Math.sqrt(dr * dr + dg * dg + db * db);
      }

      function isBackgroundCandidate(offset) {
        const a = data[offset + 3];
        if (a <= 8) return true;

        const r = data[offset];
        const g = data[offset + 1];
        const b = data[offset + 2];

        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const spread = max - min;
        const avg = (r + g + b) / 3;
        const distance = colourDistance(
          r, g, b,
          background.r, background.g, background.b
        );

        // Normal white / near-white background.
        if (avg >= 244 && spread <= 34) return true;

        // Adaptive pale grey or white background based on the sampled image edge.
        if (distance <= 40 && spread <= 34 && avg >= 165) return true;

        // Wider tolerance for neutral grey vignettes and AI-generated
        // background shadows. This remains safe because only pixels connected
        // to the outside edge can be removed by the flood fill.
        if (distance <= 92 && spread <= 34 && avg >= 155) return true;

        // Soft neutral grey glow fading towards the outside.
        if (avg >= 172 && spread <= 34) return true;

        // Semi-transparent light or neutral halo.
        if (a < 190 && avg >= 145 && spread <= 44) return true;

        return false;
      }

      function push(x, y, tailRef) {
        if (x < 0 || y < 0 || x >= width || y >= height) return tailRef;

        const p = posIndex(x, y);
        if (visited[p]) return tailRef;

        const offset = p * 4;
        if (!isBackgroundCandidate(offset)) return tailRef;

        visited[p] = 1;
        queue[tailRef] = p;
        return tailRef + 1;
      }

      let head = 0;
      let tail = 0;

      // Start only from the outside edge, preserving white artwork details.
      for (let x = 0; x < width; x++) {
        tail = push(x, 0, tail);
        tail = push(x, height - 1, tail);
      }

      for (let y = 0; y < height; y++) {
        tail = push(0, y, tail);
        tail = push(width - 1, y, tail);
      }

      while (head < tail) {
        const p = queue[head++];
        const x = p % width;
        const y = Math.floor(p / width);

        tail = push(x + 1, y, tail);
        tail = push(x - 1, y, tail);
        tail = push(x, y + 1, tail);
        tail = push(x, y - 1, tail);
        tail = push(x + 1, y + 1, tail);
        tail = push(x - 1, y - 1, tail);
        tail = push(x + 1, y - 1, tail);
        tail = push(x - 1, y + 1, tail);
      }

      for (let p = 0; p < total; p++) {
        if (visited[p]) data[p * 4 + 3] = 0;
      }

      // The connected background is now removed. Any remaining antialias
      // fringe is handled by one lightweight adaptive edge scan below.
    }

    function lightweightEdgeCleanup(imageData) {
      const { width, height, data } = imageData;
      const total = width * height;

      function runPass(strength) {
        const alpha = new Uint8Array(total);
        for (let p = 0; p < total; p++) alpha[p] = data[p * 4 + 3];

        const remove = new Uint8Array(total);
        let edgeCount = 0;
        let candidateCount = 0;

        for (let y = 1; y < height - 1; y++) {
          const row = y * width;
          for (let x = 1; x < width - 1; x++) {
            const p = row + x;
            const a = alpha[p];
            if (a === 0) continue;

            const neighbours = [
              p - 1, p + 1, p - width, p + width,
              p - width - 1, p - width + 1,
              p + width - 1, p + width + 1
            ];

            let transparentNeighbours = 0;
            for (const neighbour of neighbours) {
              if (alpha[neighbour] === 0) transparentNeighbours++;
            }
            if (transparentNeighbours === 0) continue;
            edgeCount++;

            const offset = p * 4;
            const r = data[offset];
            const g = data[offset + 1];
            const b = data[offset + 2];
            const max = Math.max(r, g, b);
            const min = Math.min(r, g, b);
            const spread = max - min;
            const avg = (r + g + b) / 3;

            // Only peel pixels that look like soft white-background
            // antialiasing. Dark and strongly coloured edges are preserved.
            const softAlpha = a < (strength === 1 ? 238 : 250);
            const paleNeutral =
              avg >= (strength === 1 ? 190 : 168) &&
              spread <= (strength === 1 ? 48 : 58);
            const aiGreyFringe =
              avg >= (strength === 1 ? 158 : 145) &&
              spread <= (strength === 1 ? 34 : 44) &&
              transparentNeighbours >= 2;
            const heavilyExposed =
              transparentNeighbours >= (strength === 1 ? 3 : 2) &&
              a < 255;

            if (
              (softAlpha && transparentNeighbours >= 1) ||
              (paleNeutral && transparentNeighbours >= 2) ||
              aiGreyFringe ||
              heavilyExposed
            ) {
              remove[p] = 1;
              candidateCount++;
            }
          }
        }

        if (!candidateCount) return { removed: 0, edgeCount };

        for (let p = 0; p < total; p++) {
          if (remove[p]) data[p * 4 + 3] = 0;
        }

        return { removed: candidateCount, edgeCount };
      }

      // One conservative pass is normally enough. A second pass is only run
      // when the first pass proves that a meaningful soft fringe exists.
      const first = runPass(1);
      if (
        first.removed >= 24 &&
        first.edgeCount > 0 &&
        first.removed / first.edgeCount >= 0.08
      ) {
        runPass(2);
      }
    }

    function rebuildContour() {
      if (!state.alphaMask) return;
      const w = state.maskWidth;
      const h = state.maskHeight;

      state.contourIsGeometric = false;

      if (state.shape !== 'die-cut') {
        state.contourIsGeometric = true;

        const visibleBounds = getOpaqueMaskBounds(
          state.alphaMask,
          w,
          h,
          {
            x: state.artworkX,
            y: state.artworkY,
            width: state.artworkWidth,
            height: state.artworkHeight
          }
        );

        state.artworkClipContour = makeGeometricContour(
          state.shape,
          w,
          h,
          visibleBounds,
          state.cornerRadiusMm,
          1,
          0
        );

        const clipBounds = contourBounds(state.artworkClipContour);
        const clipLongestPixels = Math.max(
          1,
          clipBounds.maxX - clipBounds.minX,
          clipBounds.maxY - clipBounds.minY
        );

        const requestedCutlineOffsetMm = getRequestedCutlineOffsetMm();
        const geometricMmPerPixel =
          getEffectiveVisibleSizeMm(requestedCutlineOffsetMm) / clipLongestPixels;
        const expansionPx = requestedCutlineOffsetMm / geometricMmPerPixel;

        state.contour = makeGeometricContour(
          state.shape,
          w,
          h,
          visibleBounds,
          state.cornerRadiusMm,
          geometricMmPerPixel,
          expansionPx
        );
        state.complexContour = false;
        if (el.complexWarning) {
          el.complexWarning.hidden = true;
          el.complexWarning.style.display = 'none';
        }
        clampArtworkOffset();
        return;
      }

      // Finished width describes the visible artwork rather than the padded
      // processing canvas, so all physical offsets use the artwork width.
      const mmPerPixel = getMmPerArtworkPixel();

      // A JPG or fully opaque PNG has no transparent cut information. In that
      // case, die-cut should follow the image's rectangular boundary rather
      // than inventing an irregular contour from internal artwork colours.
      if (isArtworkRectangleOpaque(
        state.alphaMask,
        w,
        h,
        state.artworkX,
        state.artworkY,
        state.artworkWidth,
        state.artworkHeight
      )) {
        const tightLongestPixels = Math.max(1, state.artworkWidth, state.artworkHeight);
        const requestedCutlineOffsetMm = getRequestedCutlineOffsetMm();
        const contourMmPerPixel =
          getEffectiveVisibleSizeMm(requestedCutlineOffsetMm) / tightLongestPixels;
        const cutlineOffsetPixels = requestedCutlineOffsetMm / contourMmPerPixel;

        state.contourIsGeometric = true;
        const oneMmRadiusPx = 1 / contourMmPerPixel;
        state.artworkClipContour = makeRoundedRectangleContour(
          state.artworkX,
          state.artworkY,
          state.artworkWidth,
          state.artworkHeight,
          oneMmRadiusPx
        );
        state.contour = makeRoundedRectangleContour(
          state.artworkX - cutlineOffsetPixels,
          state.artworkY - cutlineOffsetPixels,
          Math.max(1, state.artworkWidth + cutlineOffsetPixels * 2),
          Math.max(1, state.artworkHeight + cutlineOffsetPixels * 2),
          Math.max(0, oneMmRadiusPx + cutlineOffsetPixels)
        );
        clampArtworkOffset();
        return;
      }
      state.artworkClipContour = [];

      // Remove only the final pale antialias fringe before separate artwork
      // components are joined. Doing this after joining can reopen thin bridges
      // and cause the contour tracer to ignore wording outside the main badge.
      let contourSourceMask = state.alphaMask;

      if (!el.borderEnabled.checked && el.removeWhite.checked) {
        const fringePeelPx = 1;
        contourSourceMask = erodeMask(
          state.alphaMask,
          w,
          h,
          fringePeelPx
        );
      }

      // Build one coherent sticker silhouette from all meaningful artwork
      // parts. Start tight, then progressively bridge only as much as needed
      // to connect separate elements such as a logo and wording underneath.
      let joinedMask = buildUnifiedStickerMask(
        contourSourceMask,
        w,
        h,
        mmPerPixel
      );

      // Cut smoothing also closes narrow inward channels before the contour
      // is traced. This stops the path travelling into tiny gaps between
      // nearby artwork elements such as lettering, outlines and small details.
      // At smoothing 0 the artwork mask remains unchanged.
      if (state.smoothing > 0) {
        const gapCloseMm = Math.min(
          4.5,
          0.55 + state.smoothing * 0.30
        );
        const gapCloseRadius = Math.max(
          1,
          Math.round((gapCloseMm / mmPerPixel) / 2)
        );

        joinedMask = closeMask(
          joinedMask,
          w,
          h,
          Math.min(gapCloseRadius, 48)
        );
      }

      // Trace from a softened silhouette rather than the hard binary mask.
      // This rounds stepped shelves and abrupt vertical drops before points
      // are generated, producing a broader production-style cut outline.
      const hasBorder = el.borderEnabled.checked;

      // No-border artwork should hug the visible edge closely after background
      // removal. Bordered artwork can use stronger silhouette softening because
      // the border itself provides the intended production allowance.
      // Keep the source silhouette equally tight whether a border is enabled
      // or not. Border growth is applied after tracing, so stronger pre-border
      // softening would bridge deep transparent recesses such as the inside of
      // a neck, handle or letter shape.
      const contourSoftenMm = Math.min(
        1.05,
        0.28 + state.smoothing * 0.075
      );

      const contourSoftenPx = Math.min(
        12,
        Math.max(1, Math.round(contourSoftenMm / mmPerPixel))
      );

      joinedMask = softenContourMask(
        joinedMask,
        w,
        h,
        contourSoftenPx,
        126
      );

      const tightContour = traceLargestContour(joinedMask, w, h);
      const tightBounds = tightContour.length
        ? contourBounds(tightContour)
        : {
            minX: state.artworkX,
            minY: state.artworkY,
            maxX: state.artworkX + state.artworkWidth,
            maxY: state.artworkY + state.artworkHeight
          };

      const tightLongestPixels = Math.max(
        1,
        tightBounds.maxX - tightBounds.minX,
        tightBounds.maxY - tightBounds.minY
      );

      // Finished size means the final cut size. Calculate border thickness
      // from the tight visible contour, not from the original upload canvas.
      const requestedCutlineOffsetMm = getRequestedCutlineOffsetMm();
      const effectiveVisibleMm = getEffectiveVisibleSizeMm(requestedCutlineOffsetMm);

      const contourMmPerPixel =
        effectiveVisibleMm / tightLongestPixels;

      const requestedCutlineOffsetPixels = requestedCutlineOffsetMm / contourMmPerPixel;

      // Smoothing can pull a curve inward across sharp concave corners.
      // Add a very small outward safety allowance only when smoothing is used.
      const smoothingSafetyMm = state.smoothing > 0
        ? Math.min(0.6, 0.12 + state.smoothing * 0.04)
        : 0;

      const smoothingSafetyPixels = Math.round(
        smoothingSafetyMm / contourMmPerPixel
      );

      const roundedRequestedOffsetPixels = Math.round(requestedCutlineOffsetPixels);
      const totalOffset = roundedRequestedOffsetPixels >= 0
        ? Math.min(
            100,
            roundedRequestedOffsetPixels + Math.max(0, smoothingSafetyPixels)
          )
        : Math.max(-100, roundedRequestedOffsetPixels);

      let contour;

      // Inward adjustments still use a conservative mask erosion. Positive
      // offsets no longer dilate the raster mask, because that can flatten
      // broad rounded tops before the contour is traced. Instead, trace the
      // original silhouette and expand the cleaned vector contour afterwards.
      const contourMask = totalOffset < 0
        ? erodeMask(joinedMask, w, h, Math.abs(totalOffset))
        : joinedMask;

      contour = traceLargestContour(contourMask, w, h);

      if (!contour.length) {
        contour = makeGeometricContour('rectangle', w, h);
      }

      // Remove tiny pixel steps first, then round corners with several light
      // smoothing passes. This produces a cleaner production-style contour
      // without pulling the line far away from the artwork.
      // Preserve more of the original silhouette. The previous settings
      // rounded away too much detail around corners and narrow joins.
      // Even level 0 receives a light production cleanup. Previously level
      // 0 returned the raw mask trace, which kept square corners and every
      // small pixel step regardless of later smoothing improvements.
      const hasVisibleBorder = el.borderEnabled.checked;
      const epsilon = hasVisibleBorder
        ? Math.max(0.7, 0.7 + state.smoothing * 0.24)
        : Math.max(0.38, 0.38 + state.smoothing * 0.14);

      contour = simplifyRDP(closeLoop(contour), epsilon);

      // No-border contours use fewer rounding passes so they remain close to
      // the cleaned artwork edge. Bordered contours retain the softer outline.
      const smoothPasses = hasVisibleBorder
        ? Math.min(5, 1 + Math.ceil(state.smoothing / 3))
        : Math.min(3, 1 + Math.floor(state.smoothing / 4));
      contour = chaikin(contour, smoothPasses);

      // Apply positive border / cut-line offsets only after the contour has
      // been cleaned and rounded. Radial expansion is stable for irregular
      // die-cuts and preserves broad curved tops without creating spikes.
      if (totalOffset > 0) {
        contour = expandContourWithRoundedStroke(
          contour,
          w,
          h,
          totalOffset
        );
      }

      // Remove points added by curve subdivision using a physical tolerance,
      // then progressively simplify until the production path has a sensible
      // number of anchors. This keeps smooth curves without exporting hundreds
      // of near-identical points.
      const productionTolerancePx = Math.max(
        0.55,
        Math.min(
          3.5,
          (hasVisibleBorder ? 0.16 : 0.10) / contourMmPerPixel
        )
      );

      contour = simplifyContourForProduction(
        closeLoop(contour),
        productionTolerancePx,
        hasVisibleBorder ? 180 : 220
      );

      state.contour = contour;
      state.complexContour = detectComplexContour(
        contour,
        joinedMask,
        w,
        h
      );

      if (el.complexWarning) {
        el.complexWarning.hidden = !state.complexContour;
        el.complexWarning.style.display =
          state.complexContour ? 'block' : 'none';
      }
    }

    function detectComplexContour(points, mask, w, h) {
      if (!points || points.length < 4) return false;

      const loop = samePoint(points[0], points[points.length - 1])
        ? points.slice(0, -1)
        : points;

      const bounds = contourBounds(loop);
      const width = Math.max(1, bounds.maxX - bounds.minX);
      const height = Math.max(1, bounds.maxY - bounds.minY);
      const perimeterScale = Math.max(1, width + height);

      // Point count alone is unreliable because long, smooth outlines can
      // contain many sampled points. Use point density relative to the overall
      // sticker size instead.
      const pointDensity = loop.length / perimeterScale;
      const pointDensityThreshold = state.smoothing >= 3 ? 1.65 : 2.25;
      const denseContourComplex = pointDensity > pointDensityThreshold;

      let verySharpTurns = 0;
      let clusteredSharpTurns = 0;
      let previousSharpIndex = -100;

      for (let i = 0; i < loop.length; i++) {
        const a = loop[(i - 3 + loop.length) % loop.length];
        const b = loop[i];
        const c = loop[(i + 3) % loop.length];

        const v1x = a[0] - b[0];
        const v1y = a[1] - b[1];
        const v2x = c[0] - b[0];
        const v2y = c[1] - b[1];

        const len1 = Math.hypot(v1x, v1y) || 1;
        const len2 = Math.hypot(v2x, v2y) || 1;
        const dot = (v1x * v2x + v1y * v2y) / (len1 * len2);
        const angle = Math.acos(clamp(dot, -1, 1)) * 180 / Math.PI;

        if (angle < 24) {
          verySharpTurns++;
          if (i - previousSharpIndex <= 7) clusteredSharpTurns++;
          previousSharpIndex = i;
        }
      }

      const sharpThreshold = state.smoothing >= 3 ? 24 : 16;
      const clusterThreshold = state.smoothing >= 3 ? 12 : 8;
      const sharpComplex =
        verySharpTurns >= sharpThreshold &&
        clusteredSharpTurns >= clusterThreshold;

      let extremeNarrowGapComplex = false;

      if (mask && w && h && state.smoothing < 7) {
        const closeRadius = Math.max(4, 7 - Math.floor(state.smoothing / 2));
        const stronglyClosed = closeMask(mask, w, h, closeRadius);

        let changed = 0;
        let solid = 0;

        for (let i = 0; i < mask.length; i++) {
          if (mask[i]) solid++;
          if (stronglyClosed[i] !== mask[i]) changed++;
        }

        const changedRatio = solid ? changed / solid : 0;

        // Only flag when gap closing materially changes the silhouette.
        const ratioThreshold = 0.07 + state.smoothing * 0.012;
        const pixelThreshold = 500 + state.smoothing * 120;

        extremeNarrowGapComplex =
          changed > pixelThreshold &&
          changedRatio > ratioThreshold;
      }

      return denseContourComplex || sharpComplex || extremeNarrowGapComplex;
    }

    function updateMatchedVariant() {
      const catalog = state.variantCatalog;
      if (!catalog || !Array.isArray(catalog.variants) || !catalog.variants.length) {
        state.selectedVariant = null;
        if (el.livePrice) el.livePrice.textContent = '';
        if (el.variantStatus) {
          el.variantStatus.textContent = 'No Shopify product variants are available.';
        }
        if (el.add) el.add.disabled = true;
        return;
      }

      const optionNames = Array.isArray(catalog.options)
        ? catalog.options.map(option => normaliseVariantValue(option))
        : [];

      const sizeIndex = optionNames.findIndex(name =>
        /(size|width|height|longest side|finished size|finished width|sticker size|diameter)/i.test(name)
      );

      const quantityIndex = optionNames.findIndex(name =>
        /(quantity|qty|pack|amount|number)/i.test(name)
      );

      const matched = catalog.variants.find(variant => {
        if (!variant.available) return false;

        if (catalog.variants.length === 1 && variant.title === 'Default Title') {
          return true;
        }

        const values = Array.isArray(variant.options)
          ? variant.options.map(normaliseVariantValue)
          : [];

        const widthMatches =
          sizeIndex >= 0 && values[sizeIndex] !== undefined
            ? numericOptionMatches(values[sizeIndex], state.widthMm)
            : [variant.title, ...values]
                .filter(Boolean)
                .some(value => variantValueMatchesWidth(value, state.widthMm));

        const quantityMatches =
          quantityIndex >= 0 && values[quantityIndex] !== undefined
            ? numericOptionMatches(values[quantityIndex], state.quantity)
            : [variant.title, ...values]
                .filter(Boolean)
                .some(value => variantValueMatchesQuantity(value, state.quantity));

        return widthMatches && quantityMatches;
      });

      state.selectedVariant = matched || null;

      if (!matched) {
        if (el.livePrice) el.livePrice.textContent = 'Unavailable';
        if (el.variantStatus) {
          el.variantStatus.textContent =
            `${trimNumber(state.widthMm)} mm longest side × ${state.quantity} does not have a matching product variant.`;
        }
        if (el.add) el.add.disabled = true;
        return;
      }

      root.dataset.variantId = String(matched.id);

      if (el.livePrice) {
        el.livePrice.textContent = formatShopifyMoney(matched.price);
      }

      if (el.variantStatus) {
        el.variantStatus.textContent =
          `${trimNumber(state.widthMm)} mm longest side × ${state.quantity} selected`;
      }

      updateAddButtonState();
    }

    function numericOptionMatches(value, target) {
      const numbers = String(value || '').match(/-?\d+(?:[.,]\d+)?/g);
      if (!numbers || !numbers.length) return false;

      const targetNumber = Number(target);
      return numbers.some(number =>
        Math.abs(Number(number.replace(',', '.')) - targetNumber) < 0.001
      );
    }

    function normaliseVariantValue(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/millimetres?|millimeters?/g, 'mm')
        .replace(/[×x]/g, ' x ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function variantValueMatchesWidth(value, widthMm) {
      if (numericOptionMatches(value, widthMm) &&
          /mm|millimet|size|width|diameter/i.test(value)) {
        return true;
      }

      const width = trimNumber(widthMm);
      const patterns = [
        new RegExp(`(^|\\D)${escapeRegExp(width)}\\s*mm($|\\D)`, 'i'),
        new RegExp(`(^|\\D)${escapeRegExp(width)}\\s*(?:millimetres?|millimeters?)($|\\D)`, 'i')
      ];

      return patterns.some(pattern => pattern.test(value));
    }

    function variantValueMatchesQuantity(value, quantity) {
      if (numericOptionMatches(value, quantity) &&
          /stickers?|pcs?|pieces?|packs?|pk|qty|quantity|amount|number/i.test(value)) {
        return true;
      }

      const qty = String(quantity);
      const explicitPatterns = [
        new RegExp(`(^|\\D)${escapeRegExp(qty)}\\s*(?:stickers?|pcs?|pieces?|packs?|pk)($|\\D)`, 'i'),
        new RegExp(`(?:qty|quantity)\\s*[:=-]?\\s*${escapeRegExp(qty)}($|\\D)`, 'i'),
        new RegExp(`(^|\\D)${escapeRegExp(qty)}\\s*x($|\\D)`, 'i')
      ];

      if (explicitPatterns.some(pattern => pattern.test(value))) return true;

      return numericOptionMatches(value, quantity);
    }

    function escapeRegExp(value) {
      return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function formatShopifyMoney(cents) {
      const amount = Number(cents || 0) / 100;
      const format = root.dataset.moneyFormat || '£{{amount}}';
      const formatted = amount.toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(amount).toLocaleString('en-GB'))
        .replace(/\{\{\s*amount\s*\}\}/g, formatted)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, formatted.replace('.', ','));
    }

    function getLongestArtworkPixels() {
      return Math.max(
        1,
        state.artworkWidth || state.sourceWidth || 1,
        state.artworkHeight || state.sourceHeight || 1
      );
    }

    function getMmPerArtworkPixel() {
      return state.widthMm / getLongestArtworkPixels();
    }

    function updateFinishedDimensions() {
      if (!el.finishedDimensions || !state.artworkWidth || !state.artworkHeight) return;

      const longestPixels = Math.max(state.artworkWidth, state.artworkHeight);
      let width = state.widthMm * (state.artworkWidth / longestPixels);
      let height = state.widthMm * (state.artworkHeight / longestPixels);

      if (state.shape === 'circle' || state.shape === 'square') {
        width = state.widthMm;
        height = state.widthMm;
      } else if (state.shape === 'rectangle') {
        const ratio = state.artworkWidth / Math.max(1, state.artworkHeight);
        const nearlySquare = ratio >= 0.88 && ratio <= 1.12;
        const portrait = state.artworkHeight > state.artworkWidth;
        const targetRatio = nearlySquare
          ? (portrait ? 4 / 5 : 5 / 4)
          : ratio;

        if (targetRatio >= 1) {
          width = state.widthMm;
          height = state.widthMm / targetRatio;
        } else {
          height = state.widthMm;
          width = state.widthMm * targetRatio;
        }
      }

      el.finishedDimensions.textContent =
        `${trimNumber(width)} × ${trimNumber(height)} mm`;
    }

    function updateDpi() {
      if (!state.sourceWidth) return;
      const longestSourcePixels = Math.max(
        state.sourceWidth || 0,
        state.sourceHeight || 0
      );
      const dpi = Math.round(
        longestSourcePixels / (state.widthMm / MM_PER_INCH)
      );
      state.currentDpi = dpi;
      let level = 'low';
      let label = `${dpi} DPI · Low quality`;
      if (dpi >= 300) {
        level = 'good';
        label = `${dpi} DPI · Print ready`;
      } else if (dpi >= 150) {
        level = 'ok';
        label = `${dpi} DPI · Usable`;
      }
      el.qualityBox.dataset.level = level;
      el.dpiStatus.textContent = label;
      el.dpiDetail.textContent = `Based on ${state.widthMm} mm longest finished side`;

      if (el.dpiMarker) {
        const markerPosition = clamp((dpi / 450) * 100, 0, 100);
        el.dpiMarker.style.left = `${markerPosition}%`;
        el.dpiMarker.hidden = false;
      }

      if (el.qualityAdvisory) {
        const showAdvisory = dpi >= 150 && dpi < 300;
        el.qualityAdvisory.hidden = !showAdvisory;
        el.qualityAdvisory.style.display = showAdvisory ? 'block' : 'none';
      }

      updateFinishedDimensions();
      updateQualityAcknowledgement();
    }

    function scheduleRender() {
      clearTimeout(state.renderTimer);
      state.renderTimer = setTimeout(render, 35);
    }

    function render() {
      resizeCanvasToDisplaySize(el.canvas);
      ctx.clearRect(0, 0, el.canvas.width, el.canvas.height);
      if (!state.image || !state.processedCanvas.width) return;

      const dpr = window.devicePixelRatio || 1;
      const viewportW = el.canvas.width;
      const viewportH = el.canvas.height;
      const artW = state.processedCanvas.width;
      const artH = state.processedCanvas.height;
      const bounds = contourBounds(state.contour.length ? state.contour : [
        [state.artworkX, state.artworkY],
        [state.artworkX + state.artworkWidth, state.artworkY + state.artworkHeight]
      ]);
      const visibleW = Math.max(1, bounds.maxX - bounds.minX);
      const visibleH = Math.max(1, bounds.maxY - bounds.minY);

      const displayScale = Math.min(
        (viewportW * 0.78) / visibleW,
        (viewportH * 0.72) / visibleH,
        DISPLAY_MAX / Math.max(visibleW, visibleH)
      );
      state.renderScale = displayScale;
      updateStageCursor();

      const visibleCentreX = (bounds.minX + bounds.maxX) / 2;
      const visibleCentreY = (bounds.minY + bounds.maxY) / 2;
      const x = viewportW / 2 - visibleCentreX * displayScale;
      const y = viewportH / 2 - visibleCentreY * displayScale;

      ctx.save();
      ctx.translate(x, y);
      ctx.scale(displayScale, displayScale);

      // Stickers are produced on white vinyl. Always show that white substrate
      // beneath the finished cut shape so transparent artwork never reveals
      // the preview checkerboard inside the sticker.
      if (state.contour.length) {
        drawContourFill(ctx, state.contour, '#ffffff', !state.contourIsGeometric);
      }

      if (el.borderEnabled.checked && state.contour.length) {
        drawContourFill(ctx, state.contour, state.borderColour, !state.contourIsGeometric);
      }

      drawArtworkWithZoom(ctx);

      if (el.showCutline.checked && state.contour.length) {
        ctx.save();
        ctx.setLineDash([10 / displayScale, 7 / displayScale]);
        ctx.lineDashOffset = -state.dashOffset / displayScale;
        ctx.lineWidth = Math.max(2 / displayScale, 0.9);
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.strokeStyle = '#f74302';
        if (!state.contourIsGeometric) {
          drawSmoothPath(ctx, state.contour);
        } else {
          drawPath(ctx, state.contour);
        }
        ctx.stroke();
        ctx.restore();
      }

      ctx.restore();
    }

    function drawOriginalArtworkWithZoom(targetCtx) {
      const useShapeClip =
        state.contourIsGeometric &&
        state.artworkClipContour &&
        state.artworkClipContour.length;

      targetCtx.save();

      if (useShapeClip) {
        drawPath(targetCtx, state.artworkClipContour);
        targetCtx.clip();
      }

      const zoom =
        ['circle', 'square', 'rectangle'].includes(state.shape)
          ? state.artworkZoom
          : 1;

      const offsetX = useShapeClip ? state.artworkOffsetX : 0;
      const offsetY = useShapeClip ? state.artworkOffsetY : 0;
      const centreX = state.artworkX + state.artworkWidth / 2;
      const centreY = state.artworkY + state.artworkHeight / 2;

      targetCtx.translate(centreX + offsetX, centreY + offsetY);
      targetCtx.scale(zoom, zoom);
      targetCtx.translate(-centreX, -centreY);

      // Draw directly from the original upload. The browser resamples the
      // original source into the 300 DPI export instead of enlarging the
      // reduced contour-processing canvas.
      targetCtx.drawImage(
        state.image,
        state.artworkX,
        state.artworkY,
        state.artworkWidth,
        state.artworkHeight
      );

      targetCtx.restore();
    }

    function drawArtworkWithZoom(targetCtx) {
      const useShapeClip =
        state.contourIsGeometric &&
        state.artworkClipContour &&
        state.artworkClipContour.length;

      targetCtx.save();

      if (useShapeClip) {
        drawPath(targetCtx, state.artworkClipContour);
        targetCtx.clip();
      }

      const zoom =
        ['circle', 'square', 'rectangle'].includes(state.shape)
          ? state.artworkZoom
          : 1;

      const offsetX = useShapeClip ? state.artworkOffsetX : 0;
      const offsetY = useShapeClip ? state.artworkOffsetY : 0;
      const centreX = state.artworkX + state.artworkWidth / 2;
      const centreY = state.artworkY + state.artworkHeight / 2;

      targetCtx.translate(centreX + offsetX, centreY + offsetY);
      targetCtx.scale(zoom, zoom);
      targetCtx.translate(-centreX, -centreY);
      targetCtx.drawImage(state.processedCanvas, 0, 0);
      targetCtx.restore();
    }

    function buildColourBleedCanvas(sourceCanvas, alphaMask, w, h, bleedPixels) {
      const output = document.createElement('canvas');
      output.width = w;
      output.height = h;

      const sourceCtx = sourceCanvas.getContext('2d', {
        alpha: true,
        willReadFrequently: true
      });

      const sourceData = sourceCtx.getImageData(0, 0, w, h);
      const working = new Uint8ClampedArray(sourceData.data);
      const filled = new Uint8Array(w * h);

      for (let i = 0; i < filled.length; i++) {
        if (alphaMask[i]) filled[i] = 1;
      }

      const radius = Math.max(0, Math.round(bleedPixels || 0));

      // Expand one pixel at a time using all eight neighbours. New pixels use
      // an average of nearby filled colours, which avoids the vertical and
      // horizontal striping produced by a single nearest-pixel owner.
      for (let pass = 0; pass < radius; pass++) {
        const nextFilled = filled.slice();
        const nextData = new Uint8ClampedArray(working);

        for (let y = 0; y < h; y++) {
          for (let x = 0; x < w; x++) {
            const p = y * w + x;
            if (filled[p]) continue;

            let red = 0;
            let green = 0;
            let blue = 0;
            let alpha = 0;
            let count = 0;

            for (let oy = -1; oy <= 1; oy++) {
              for (let ox = -1; ox <= 1; ox++) {
                if (ox === 0 && oy === 0) continue;

                const nx = x + ox;
                const ny = y + oy;
                if (nx < 0 || ny < 0 || nx >= w || ny >= h) continue;

                const neighbour = ny * w + nx;
                if (!filled[neighbour]) continue;

                const offset = neighbour * 4;
                const weight = ox !== 0 && oy !== 0 ? 0.72 : 1;

                red += working[offset] * weight;
                green += working[offset + 1] * weight;
                blue += working[offset + 2] * weight;
                alpha += working[offset + 3] * weight;
                count += weight;
              }
            }

            if (count <= 0) continue;

            const offset = p * 4;
            nextData[offset] = Math.round(red / count);
            nextData[offset + 1] = Math.round(green / count);
            nextData[offset + 2] = Math.round(blue / count);
            nextData[offset + 3] = 255;
            nextFilled[p] = 1;
          }
        }

        working.set(nextData);
        filled.set(nextFilled);
      }

      const outCtx = output.getContext('2d', {
        alpha: true,
        willReadFrequently: true
      });

      const expanded = new ImageData(working, w, h);
      outCtx.putImageData(expanded, 0, 0);

      // Lightly soften only the expanded area. The original artwork is drawn
      // over this later, so its detail remains sharp.
      if (radius >= 2) {
        const softened = document.createElement('canvas');
        softened.width = w;
        softened.height = h;
        const softenedCtx = softened.getContext('2d');

        softenedCtx.filter = `blur(${Math.min(2, radius * 0.08)}px)`;
        softenedCtx.drawImage(output, 0, 0);
        softenedCtx.filter = 'none';

        outCtx.clearRect(0, 0, w, h);
        outCtx.drawImage(softened, 0, 0);
      }

      return output;
    }

    function drawBorderRaster(targetCtx, mask, w, h, borderMm, colour) {
      const mmPerPixel = state.widthMm / Math.max(1, w);
      const radius = Math.max(1, Math.round(borderMm / mmPerPixel));
      const expanded = dilateMask(mask, w, h, Math.min(radius, 80));
      const temp = document.createElement('canvas');
      temp.width = w;
      temp.height = h;
      const tctx = temp.getContext('2d');
      const img = tctx.createImageData(w, h);
      const rgb = hexToRgb(colour);
      for (let i = 0; i < expanded.length; i++) {
        if (!expanded[i]) continue;
        const p = i * 4;
        img.data[p] = rgb.r;
        img.data[p + 1] = rgb.g;
        img.data[p + 2] = rgb.b;
        img.data[p + 3] = 255;
      }
      tctx.putImageData(img, 0, 0);
      targetCtx.drawImage(temp, 0, 0);
    }

    async function downloadProof() {
      if (!state.image) return;
      const canvas = buildExportCanvas({ includeCutline: true, force300: false, checker: false });
      const blob = await canvasToBlob(canvas, 'image/png');
      downloadBlob(blob, `${baseName(state.sourceFile.name)}-proof.png`);
    }

    async function downloadPrint() {
      if (!state.image) return;
      const canvas = buildExportCanvas({ includeCutline: false, force300: true, checker: false, extraFillMm: 0 });
      const blob = await canvasToBlob(canvas, 'image/png');
      state.generatedPrintBlob = blob;
      downloadBlob(blob, `${baseName(state.sourceFile.name)}-${state.widthMm}mm-print.png`);
    }

    async function downloadSvg() {
      if (!state.image || !state.contour.length) return;

      const svgBlob = await buildSvgBlob();
      downloadBlob(
        svgBlob,
        `${baseName(state.sourceFile.name)}-artwork-and-cut-path.svg`
      );
    }

    async function buildSvgBlob() {
      if (!state.image || !state.contour.length) {
        throw new Error('No cut path is available.');
      }

      const cutBounds = contourBounds(state.contour);
      const cutWidthSourcePx = Math.max(
        1,
        cutBounds.maxX - cutBounds.minX
      );
      const cutHeightSourcePx = Math.max(
        1,
        cutBounds.maxY - cutBounds.minY
      );
      const cutLongestSourcePx = Math.max(
        cutWidthSourcePx,
        cutHeightSourcePx
      );

      // The selected size is the longest side of the final cut path.
      const mmPerCutSourcePx =
        state.widthMm / cutLongestSourcePx;

      const svgWidthMm =
        cutWidthSourcePx * mmPerCutSourcePx;
      const svgHeightMm =
        cutHeightSourcePx * mmPerCutSourcePx;

      const rasterW = Math.max(
        1,
        Math.round(svgWidthMm * PRINT_DPI / MM_PER_INCH)
      );
      const rasterH = Math.max(
        1,
        Math.round(svgHeightMm * PRINT_DPI / MM_PER_INCH)
      );

      const outputPxPerSourcePx =
        PRINT_DPI / MM_PER_INCH * mmPerCutSourcePx;

      const rasterCanvas = document.createElement('canvas');
      rasterCanvas.width = rasterW;
      rasterCanvas.height = rasterH;

      const rctx = rasterCanvas.getContext('2d', {
        alpha: true,
        willReadFrequently: true
      });

      const translateX = -cutBounds.minX;
      const translateY = -cutBounds.minY;

      if (el.borderEnabled.checked) {
        rctx.save();
        rctx.scale(outputPxPerSourcePx, outputPxPerSourcePx);
        rctx.translate(translateX, translateY);
        drawContourFill(
          rctx,
          state.contour,
          state.borderColour,
          !state.contourIsGeometric
        );
        rctx.restore();
      }

      const artworkLayer = document.createElement('canvas');
      artworkLayer.width = rasterW;
      artworkLayer.height = rasterH;

      const actx = artworkLayer.getContext('2d', {
        alpha: true,
        willReadFrequently: true
      });

      actx.save();
      actx.scale(outputPxPerSourcePx, outputPxPerSourcePx);
      actx.translate(translateX, translateY);
      drawOriginalArtworkWithZoom(actx);
      actx.restore();

      if (el.removeWhite.checked) {
        const highResolutionArtwork = actx.getImageData(
          0,
          0,
          artworkLayer.width,
          artworkLayer.height
        );
        cleanConnectedArtworkBackground(
          highResolutionArtwork,
          null,
          state.backgroundCleanupMode
        );
        lightweightEdgeCleanup(highResolutionArtwork);
        actx.putImageData(highResolutionArtwork, 0, 0);
      }

      rctx.drawImage(artworkLayer, 0, 0);

      const artworkData = rasterCanvas.toDataURL('image/png');

      const path = contourToSvgPath(
        state.contour,
        mmPerCutSourcePx,
        -cutBounds.minX * mmPerCutSourcePx,
        -cutBounds.minY * mmPerCutSourcePx,
        !state.contourIsGeometric
      );

      const svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg"
     xmlns:xlink="http://www.w3.org/1999/xlink"
     width="${trimNumber(svgWidthMm)}mm"
     height="${trimNumber(svgHeightMm)}mm"
     viewBox="0 0 ${trimNumber(svgWidthMm)} ${trimNumber(svgHeightMm)}">
  <image id="Artwork"
         x="0"
         y="0"
         width="${trimNumber(svgWidthMm)}"
         height="${trimNumber(svgHeightMm)}"
         preserveAspectRatio="none"
         href="${artworkData}"
         xlink:href="${artworkData}"/>
  <path id="CutContour"
        d="${path}"
        fill="none"
        stroke="#ff00ff"
        stroke-width="0.25"
        stroke-linejoin="round"
        stroke-linecap="round"
        vector-effect="non-scaling-stroke"/>
</svg>`;

      return new Blob([svg], {
        type: 'image/svg+xml;charset=utf-8'
      });
    }

    function buildExportCanvas({ includeCutline, force300, extraFillMm = 0, fixedPaddingMm = null }) {
      const baseW = state.processedCanvas.width;
      const baseH = state.processedCanvas.height;
      const longestArtworkPixels = Math.max(
        1,
        state.artworkWidth,
        state.artworkHeight
      );
      const targetLongestPixels = force300
        ? Math.max(1, Math.round(state.widthMm / MM_PER_INCH * PRINT_DPI))
        : longestArtworkPixels;
      const scale = targetLongestPixels / longestArtworkPixels;
      const outputW = Math.max(1, Math.round(baseW * scale));
      const outputH = Math.max(1, Math.round(baseH * scale));
      const naturalPadMm = extraFillMm + 3;
      const padMm = fixedPaddingMm === null ? naturalPadMm : fixedPaddingMm;
      const pad = Math.ceil((padMm / state.widthMm) * outputW);

      const canvas = document.createElement('canvas');
      canvas.width = outputW + pad * 2;
      canvas.height = outputH + pad * 2;
      const c = canvas.getContext('2d');

      c.save();
      c.translate(pad, pad);
      c.scale(scale, scale);

      // Customer proofs must show the white vinyl beneath transparent artwork.
      // Keep production artwork transparent when no proof cut line is requested.
      if (includeCutline && state.contour.length) {
        drawContourFill(c, state.contour, '#ffffff', !state.contourIsGeometric);
      }

      if (el.borderEnabled.checked && state.contour.length) {
        if (extraFillMm > 0) {
          // For print bleed, expand the contour by the requested physical
          // amount before filling it.
          const mmPerPixel = getMmPerArtworkPixel();
          const expandedContour = expandContour(
            state.contour,
            extraFillMm / mmPerPixel
          );
          drawContourFill(c, expandedContour, state.borderColour, !state.contourIsGeometric);
        } else {
          drawContourFill(c, state.contour, state.borderColour, !state.contourIsGeometric);
        }
      }

      drawArtworkWithZoom(c);

      if (includeCutline && state.contour.length) {
        c.setLineDash([6 / scale, 4 / scale]);
        c.lineWidth = 1.7 / scale;
        c.lineCap = 'round';
        c.lineJoin = 'round';
        c.strokeStyle = '#f74302';
        if (!state.contourIsGeometric) {
          drawSmoothPath(c, state.contour);
        } else {
          drawPath(c, state.contour);
        }
        c.stroke();
      }

      c.restore();
      return canvas;
    }

    async function addToCart() {
      const variantId = state.selectedVariant?.id || root.dataset.variantId;
      if (!variantId || !state.sourceFile) return;

      try {
        el.add.disabled = true;
        setStatus('Preparing artwork…');

        const proofCanvas = buildExportCanvas({ includeCutline: true, force300: false });
        const proofBlob = await canvasToBlob(proofCanvas, 'image/png');
        const svgBlob = await buildSvgBlob();

        const form = new FormData();
        form.append('id', variantId);
        form.append('quantity', '1');
        form.append('properties[Shape]', titleCase(state.shape));
        if (['square', 'rectangle'].includes(state.shape)) {
          form.append('properties[Corner radius]', `${trimNumber(state.cornerRadiusMm)} mm`);
        }
        form.append(
          'properties[_Original artwork]',
          state.sourceFile,
          state.sourceFile.name
        );
        form.append(
          'properties[_Generated proof]',
          new File(
            [proofBlob],
            `${baseName(state.sourceFile.name)}-proof.png`,
            { type: 'image/png' }
          )
        );
        form.append(
          'properties[_Generated SVG cut file]',
          new File(
            [svgBlob],
            `${baseName(state.sourceFile.name)}-artwork-and-cut-path.svg`,
            { type: 'image/svg+xml' }
          )
        );

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: form,
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || 'Unable to add this item.');
        }

        setStatus('Added to your basket.');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(() => { window.location.href = '/cart'; }, 600);
      } catch (error) {
        console.error(error);
        setStatus(error.message || 'Could not add the artwork to your basket.', true);
        el.add.disabled = false;
      }
    }

    function clearArtwork() {
      state.sourceFile = null;
      state.image = null;
      state.sourceWidth = 0;
      state.sourceHeight = 0;
      state.sourceHasTransparency = false;
      state.alphaMask = null;
      state.contour = [];
      state.artworkClipContour = [];
      state.artworkOffsetX = 0;
      state.artworkOffsetY = 0;
      state.contentBounds = null;
      state.contentDetection = null;
      state.currentDpi = 0;
      state.backgroundCleanupMode = 'light';
      state.complexContour = false;
      state.isDraggingArtwork = false;
      state.processedCanvas.width = 1;
      state.processedCanvas.height = 1;
      el.input.value = '';
      if (el.artworkApproval) el.artworkApproval.checked = false;
      clearSampledColours();
      if (el.recommendSettingsHelper) {
        el.recommendSettingsHelper.hidden = true;
        el.recommendSettingsHelper.classList.remove('is-attention');
      }
      if (el.recommendedSettingsStatus) el.recommendedSettingsStatus.hidden = true;
      el.fileLabel.textContent = 'Choose artwork';
      updateTransparencyWarning();
      el.empty.hidden = false;
      ctx.clearRect(0, 0, el.canvas.width, el.canvas.height);
      el.qualityBox.removeAttribute('data-level');
      el.dpiStatus.textContent = 'Upload artwork to check quality';
      el.dpiDetail.textContent = '';
      if (el.dpiMarker) {
        el.dpiMarker.hidden = true;
        el.dpiMarker.style.left = '0%';
      }
      if (el.qualityAdvisory) {
        el.qualityAdvisory.hidden = true;
        el.qualityAdvisory.style.display = 'none';
      }
      if (el.finishedDimensions) el.finishedDimensions.textContent = '—';
      if (el.qualityConfirm) el.qualityConfirm.hidden = true;
      if (el.positioningWarning) el.positioningWarning.hidden = true;
      if (el.complexWarning) {
        el.complexWarning.hidden = true;
        el.complexWarning.style.display = 'none';
      }
      setEnabled(false);
      setStatus('');
      updateStageCursor();
    }

    function setEnabled(enabled) {
      [el.proof, el.print, el.svg, el.clear].forEach(item => { if (item) item.disabled = !enabled; });
      updateAddButtonState();
    }

    function setBusy(busy) {
      root.classList.toggle('is-busy', busy);
    }

    function setStatus(message, isError = false) {
      if (!el.cartStatus) return;
      el.cartStatus.textContent = message;
      el.cartStatus.style.color = isError ? '#b42318' : '';
    }
  }

  function fileToImage(file) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(url);
        resolve(img);
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('Image load failed'));
      };
      img.src = url;
    });
  }

  function resizeCanvasToDisplaySize(canvas) {
    const rect = canvas.getBoundingClientRect();
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const width = Math.max(1, Math.round(rect.width * dpr));
    const height = Math.max(1, Math.round(rect.height * dpr));
    if (canvas.width !== width || canvas.height !== height) {
      canvas.width = width;
      canvas.height = height;
    }
  }

  function makeAlphaMask(imageData, threshold = 18) {
    const mask = new Uint8Array(imageData.width * imageData.height);
    for (let i = 0; i < mask.length; i++) {
      mask[i] = imageData.data[i * 4 + 3] > threshold ? 1 : 0;
    }
    return mask;
  }

  function softenContourMask(mask, w, h, radius, threshold = 92) {
    if (!mask || !mask.length || radius <= 0) {
      return mask ? mask.slice() : [];
    }

    const source = document.createElement('canvas');
    source.width = w;
    source.height = h;

    const sourceCtx = source.getContext('2d', {
      alpha: true,
      willReadFrequently: true
    });

    const image = sourceCtx.createImageData(w, h);
    for (let i = 0; i < mask.length; i++) {
      if (!mask[i]) continue;
      const offset = i * 4;
      image.data[offset] = 255;
      image.data[offset + 1] = 255;
      image.data[offset + 2] = 255;
      image.data[offset + 3] = 255;
    }
    sourceCtx.putImageData(image, 0, 0);

    const softened = document.createElement('canvas');
    softened.width = w;
    softened.height = h;

    const softenedCtx = softened.getContext('2d', {
      alpha: true,
      willReadFrequently: true
    });

    // Multiple smaller blur passes are more consistent across browsers than
    // one very large blur and create a cleaner rounded outer silhouette.
    const passes = radius >= 10 ? 2 : 1;
    const passRadius = radius / passes;

    let current = source;
    for (let pass = 0; pass < passes; pass++) {
      const target = document.createElement('canvas');
      target.width = w;
      target.height = h;
      const targetCtx = target.getContext('2d');

      targetCtx.filter = `blur(${passRadius}px)`;
      targetCtx.drawImage(current, 0, 0);
      targetCtx.filter = 'none';
      current = target;
    }

    softenedCtx.drawImage(current, 0, 0);

    const blurred = softenedCtx.getImageData(0, 0, w, h).data;
    const output = new Uint8Array(w * h);

    for (let i = 0; i < output.length; i++) {
      output[i] = blurred[i * 4 + 3] >= threshold ? 1 : 0;
    }

    // A tiny close removes isolated pinches introduced by thresholding.
    return closeMask(
      output,
      w,
      h,
      Math.min(3, Math.max(1, Math.round(radius * 0.16)))
    );
  }

  function dilateMask(mask, w, h, radius) {
    if (radius <= 0) return mask.slice();
    const horizontal = new Uint8Array(mask.length);
    const output = new Uint8Array(mask.length);

    for (let y = 0; y < h; y++) {
      let count = 0;
      for (let x = -radius; x <= radius; x++) {
        if (x >= 0 && x < w) count += mask[y * w + x];
      }
      for (let x = 0; x < w; x++) {
        horizontal[y * w + x] = count > 0 ? 1 : 0;
        const removeX = x - radius;
        const addX = x + radius + 1;
        if (removeX >= 0) count -= mask[y * w + removeX];
        if (addX < w) count += mask[y * w + addX];
      }
    }

    for (let x = 0; x < w; x++) {
      let count = 0;
      for (let y = -radius; y <= radius; y++) {
        if (y >= 0 && y < h) count += horizontal[y * w + x];
      }
      for (let y = 0; y < h; y++) {
        output[y * w + x] = count > 0 ? 1 : 0;
        const removeY = y - radius;
        const addY = y + radius + 1;
        if (removeY >= 0) count -= horizontal[removeY * w + x];
        if (addY < h) count += horizontal[addY * w + x];
      }
    }
    return output;
  }

  function isArtworkRectangleOpaque(mask, w, h, x, y, width, height) {
    const left = Math.max(0, Math.round(x));
    const top = Math.max(0, Math.round(y));
    const right = Math.min(w, Math.round(x + width));
    const bottom = Math.min(h, Math.round(y + height));

    let opaque = 0;
    let total = 0;
    let edgeOpaque = 0;
    let edgeTotal = 0;

    for (let py = top; py < bottom; py++) {
      for (let px = left; px < right; px++) {
        const value = mask[py * w + px] ? 1 : 0;
        opaque += value;
        total++;

        const onEdge =
          py < top + 2 ||
          py >= bottom - 2 ||
          px < left + 2 ||
          px >= right - 2;

        if (onEdge) {
          edgeOpaque += value;
          edgeTotal++;
        }
      }
    }

    const fillRatio = total ? opaque / total : 0;
    const edgeRatio = edgeTotal ? edgeOpaque / edgeTotal : 0;

    return fillRatio >= 0.985 && edgeRatio >= 0.97;
  }

  function buildUnifiedStickerMask(mask, w, h, mmPerPixel) {
    const totalOpaque = countMaskPixels(mask);
    if (!totalOpaque) return mask.slice();

    // Ignore tiny dust/noise components while preserving genuine wording and
    // separate logo elements. Components above 0.08% of the artwork remain.
    const minimumComponentArea = Math.max(10, Math.round(totalOpaque * 0.0008));
    let cleaned = removeSmallComponents(mask, w, h, minimumComponentArea);

    let components = countComponents(cleaned, w, h, minimumComponentArea);
    if (components <= 1) return cleaned;

    // Increase the closing gap gradually. This avoids a permanently oversized
    // halo while still joining artwork split across multiple transparent areas.
    const joinStepsMm = [1.5, 2.5, 3.5, 4.5, 6, 8];
    let best = cleaned;

    for (const gapMm of joinStepsMm) {
      const radius = Math.max(1, Math.round((gapMm / mmPerPixel) / 2));
      const candidate = closeMask(cleaned, w, h, Math.min(radius, 72));
      const candidateComponents = countComponents(
        candidate,
        w,
        h,
        minimumComponentArea
      );

      best = candidate;
      if (candidateComponents <= 1) break;
    }

    // If normal closing still leaves separate artwork islands, connect them
    // with narrow internal bridges. This prevents the contour tracer from
    // keeping only the largest element while avoiding a large all-over halo.
    if (countComponents(best, w, h, minimumComponentArea) > 1) {
      best = bridgeDisconnectedComponents(
        best,
        w,
        h,
        minimumComponentArea,
        mmPerPixel
      );
    }

    // A final very small dilation removes hairline separations introduced by
    // antialiasing. Erosion after this would reopen narrow bridges, so the
    // contour smoothing stage handles the slight expansion instead.
    const finishingRadius = Math.max(
      1,
      Math.round((0.35 / mmPerPixel))
    );

    return dilateMask(best, w, h, Math.min(finishingRadius, 8));
  }

  function bridgeDisconnectedComponents(mask, w, h, minimumArea, mmPerPixel) {
    const visited = new Uint8Array(mask.length);
    const queue = new Int32Array(mask.length);
    const components = [];

    for (let start = 0; start < mask.length; start++) {
      if (!mask[start] || visited[start]) continue;

      let head = 0;
      let tail = 0;
      queue[tail++] = start;
      visited[start] = 1;

      let area = 0;
      let minX = w;
      let minY = h;
      let maxX = 0;
      let maxY = 0;

      while (head < tail) {
        const index = queue[head++];
        const x = index % w;
        const y = Math.floor(index / w);
        area++;
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);

        const neighbours = [
          x > 0 ? index - 1 : -1,
          x < w - 1 ? index + 1 : -1,
          y > 0 ? index - w : -1,
          y < h - 1 ? index + w : -1
        ];

        for (const next of neighbours) {
          if (next >= 0 && mask[next] && !visited[next]) {
            visited[next] = 1;
            queue[tail++] = next;
          }
        }
      }

      if (area >= minimumArea) {
        components.push({ area, minX, minY, maxX, maxY });
      }
    }

    if (components.length <= 1) return mask.slice();

    components.sort((a, b) => b.area - a.area);
    const output = mask.slice();
    const connected = [components.shift()];
    const bridgeRadius = Math.min(
      10,
      Math.max(1, Math.round(0.65 / Math.max(mmPerPixel, 0.001)))
    );

    function closestBoxPoints(a, b) {
      const ax = a.maxX < b.minX
        ? a.maxX
        : a.minX > b.maxX
          ? a.minX
          : Math.round((Math.max(a.minX, b.minX) + Math.min(a.maxX, b.maxX)) / 2);
      const bx = a.maxX < b.minX
        ? b.minX
        : a.minX > b.maxX
          ? b.maxX
          : ax;

      const ay = a.maxY < b.minY
        ? a.maxY
        : a.minY > b.maxY
          ? a.minY
          : Math.round((Math.max(a.minY, b.minY) + Math.min(a.maxY, b.maxY)) / 2);
      const by = a.maxY < b.minY
        ? b.minY
        : a.minY > b.maxY
          ? b.maxY
          : ay;

      return { ax, ay, bx, by };
    }

    function boxDistanceSquared(a, b) {
      const points = closestBoxPoints(a, b);
      const dx = points.ax - points.bx;
      const dy = points.ay - points.by;
      return dx * dx + dy * dy;
    }

    function stamp(x, y) {
      for (let dy = -bridgeRadius; dy <= bridgeRadius; dy++) {
        for (let dx = -bridgeRadius; dx <= bridgeRadius; dx++) {
          if (dx * dx + dy * dy > bridgeRadius * bridgeRadius) continue;
          const px = x + dx;
          const py = y + dy;
          if (px >= 0 && py >= 0 && px < w && py < h) {
            output[py * w + px] = 1;
          }
        }
      }
    }

    function drawBridge(x0, y0, x1, y1) {
      const dx = Math.abs(x1 - x0);
      const sx = x0 < x1 ? 1 : -1;
      const dy = -Math.abs(y1 - y0);
      const sy = y0 < y1 ? 1 : -1;
      let error = dx + dy;
      let x = x0;
      let y = y0;

      while (true) {
        stamp(x, y);
        if (x === x1 && y === y1) break;
        const e2 = 2 * error;
        if (e2 >= dy) {
          error += dy;
          x += sx;
        }
        if (e2 <= dx) {
          error += dx;
          y += sy;
        }
      }
    }

    while (components.length) {
      let bestComponentIndex = 0;
      let bestConnectedIndex = 0;
      let bestDistance = Infinity;

      for (let i = 0; i < components.length; i++) {
        for (let j = 0; j < connected.length; j++) {
          const distance = boxDistanceSquared(components[i], connected[j]);
          if (distance < bestDistance) {
            bestDistance = distance;
            bestComponentIndex = i;
            bestConnectedIndex = j;
          }
        }
      }

      const component = components.splice(bestComponentIndex, 1)[0];
      const anchor = connected[bestConnectedIndex];
      const points = closestBoxPoints(component, anchor);
      drawBridge(points.ax, points.ay, points.bx, points.by);
      connected.push(component);
    }

    return closeMask(output, w, h, Math.min(3, bridgeRadius));
  }

  function countMaskPixels(mask) {
    let count = 0;
    for (let i = 0; i < mask.length; i++) count += mask[i] ? 1 : 0;
    return count;
  }

  function removeSmallComponents(mask, w, h, minimumArea) {
    const output = new Uint8Array(mask.length);
    const visited = new Uint8Array(mask.length);
    const queue = new Int32Array(mask.length);

    for (let start = 0; start < mask.length; start++) {
      if (!mask[start] || visited[start]) continue;

      let head = 0;
      let tail = 0;
      queue[tail++] = start;
      visited[start] = 1;
      const component = [];

      while (head < tail) {
        const index = queue[head++];
        component.push(index);
        const x = index % w;
        const y = Math.floor(index / w);

        const neighbours = [
          x > 0 ? index - 1 : -1,
          x < w - 1 ? index + 1 : -1,
          y > 0 ? index - w : -1,
          y < h - 1 ? index + w : -1
        ];

        for (const next of neighbours) {
          if (next >= 0 && mask[next] && !visited[next]) {
            visited[next] = 1;
            queue[tail++] = next;
          }
        }
      }

      if (component.length >= minimumArea) {
        for (const index of component) output[index] = 1;
      }
    }

    return output;
  }

  function countComponents(mask, w, h, minimumArea = 1) {
    const visited = new Uint8Array(mask.length);
    const queue = new Int32Array(mask.length);
    let count = 0;

    for (let start = 0; start < mask.length; start++) {
      if (!mask[start] || visited[start]) continue;

      let head = 0;
      let tail = 0;
      let area = 0;
      queue[tail++] = start;
      visited[start] = 1;

      while (head < tail) {
        const index = queue[head++];
        area++;
        const x = index % w;
        const y = Math.floor(index / w);

        const neighbours = [
          x > 0 ? index - 1 : -1,
          x < w - 1 ? index + 1 : -1,
          y > 0 ? index - w : -1,
          y < h - 1 ? index + w : -1
        ];

        for (const next of neighbours) {
          if (next >= 0 && mask[next] && !visited[next]) {
            visited[next] = 1;
            queue[tail++] = next;
          }
        }
      }

      if (area >= minimumArea) count++;
    }

    return count;
  }

  function erodeMask(mask, w, h, radius) {
    if (radius <= 0) return mask.slice();

    const inverted = new Uint8Array(mask.length);
    for (let i = 0; i < mask.length; i++) inverted[i] = mask[i] ? 0 : 1;

    const expandedOutside = dilateMask(inverted, w, h, radius);
    const output = new Uint8Array(mask.length);
    for (let i = 0; i < output.length; i++) output[i] = expandedOutside[i] ? 0 : 1;
    return output;
  }

  function closeMask(mask, w, h, radius) {
    if (radius <= 0) return mask.slice();
    return erodeMask(dilateMask(mask, w, h, radius), w, h, radius);
  }

  function traceLargestContour(mask, w, h) {
    const edges = [];
    const key = (x, y) => `${x},${y}`;
    const adjacency = new Map();

    function addEdge(ax, ay, bx, by) {
      const a = key(ax, ay), b = key(bx, by);
      if (!adjacency.has(a)) adjacency.set(a, []);
      adjacency.get(a).push([bx, by]);
      edges.push([[ax, ay], [bx, by]]);
    }

    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        if (!mask[y * w + x]) continue;
        if (y === 0 || !mask[(y - 1) * w + x]) addEdge(x, y, x + 1, y);
        if (x === w - 1 || !mask[y * w + x + 1]) addEdge(x + 1, y, x + 1, y + 1);
        if (y === h - 1 || !mask[(y + 1) * w + x]) addEdge(x + 1, y + 1, x, y + 1);
        if (x === 0 || !mask[y * w + x - 1]) addEdge(x, y + 1, x, y);
      }
    }

    const visited = new Set();
    const loops = [];

    for (const [startKey, nexts] of adjacency.entries()) {
      for (const next of nexts) {
        const edgeKey = `${startKey}>${key(next[0], next[1])}`;
        if (visited.has(edgeKey)) continue;

        const [sx, sy] = startKey.split(',').map(Number);
        const loop = [[sx, sy]];
        let current = [sx, sy];
        let target = next;
        let guard = 0;

        while (guard++ < edges.length + 10) {
          const eKey = `${key(current[0], current[1])}>${key(target[0], target[1])}`;
          if (visited.has(eKey)) break;
          visited.add(eKey);
          loop.push(target);

          if (target[0] === sx && target[1] === sy) break;
          const candidates = adjacency.get(key(target[0], target[1])) || [];
          const nextTarget = candidates.find(p => !visited.has(`${key(target[0], target[1])}>${key(p[0], p[1])}`));
          if (!nextTarget) break;
          current = target;
          target = nextTarget;
        }

        if (loop.length > 4) loops.push(loop);
      }
    }

    loops.sort((a, b) => Math.abs(polygonArea(b)) - Math.abs(polygonArea(a)));
    return loops[0] || [];
  }

  function makeGeometricContour(
    shape,
    w,
    h,
    artworkBounds = null,
    cornerRadiusMm = 1,
    mmPerPixel = 1,
    expansionPx = 0
  ) {
    const bounds = artworkBounds || {
      x: 0,
      y: 0,
      width: w,
      height: h
    };

    const pad = Math.max(2, Math.round(Math.min(bounds.width, bounds.height) * 0.01));
    const centreX = bounds.x + bounds.width / 2;
    const centreY = bounds.y + bounds.height / 2;

    if (shape === 'circle') {
      // Use the artwork diagonal so every corner remains inside the circle.
      const diameter =
        Math.hypot(bounds.width, bounds.height) +
        pad * 2 +
        expansionPx * 2;
      const radius = diameter / 2;
      const points = [];

      for (let i = 0; i < 160; i++) {
        const angle = i / 160 * Math.PI * 2;
        points.push([
          centreX + Math.cos(angle) * radius,
          centreY + Math.sin(angle) * radius
        ]);
      }

      return closeLoop(points);
    }

    const radiusPx = Math.max(0, cornerRadiusMm / Math.max(mmPerPixel, 0.0001));

    if (shape === 'square') {
      const size =
        Math.max(bounds.width, bounds.height) +
        pad * 2 +
        expansionPx * 2;
      return makeRoundedRectangleContour(
        centreX - size / 2,
        centreY - size / 2,
        size,
        size,
        radiusPx + expansionPx
      );
    }

    // Rectangle follows the artwork ratio closely. Only near-square uploads
    // are nudged to a clear rectangle so Rectangle remains visibly different
    // from Square without adding excessive empty space.
    const artworkRatio = bounds.width / Math.max(1, bounds.height);
    const isNearlySquare = artworkRatio >= 0.88 && artworkRatio <= 1.12;
    const isPortrait = bounds.height > bounds.width;

    const targetRatio = isNearlySquare
      ? (isPortrait ? 4 / 5 : 5 / 4)
      : artworkRatio;

    const minimumWidth = bounds.width + pad * 2;
    const minimumHeight = bounds.height + pad * 2;

    let rectangleWidth = minimumWidth;
    let rectangleHeight = minimumHeight;

    if (isNearlySquare) {
      if (minimumWidth / minimumHeight > targetRatio) {
        rectangleHeight = minimumWidth / targetRatio;
      } else {
        rectangleWidth = minimumHeight * targetRatio;
      }
    }

    rectangleWidth += expansionPx * 2;
    rectangleHeight += expansionPx * 2;

    return makeRoundedRectangleContour(
      centreX - rectangleWidth / 2,
      centreY - rectangleHeight / 2,
      rectangleWidth,
      rectangleHeight,
      radiusPx + expansionPx
    );
  }

  function makeRectangleContour(x, y, width, height) {
    return [
      [x, y],
      [x + width, y],
      [x + width, y + height],
      [x, y + height],
      [x, y]
    ];
  }

  function makeRoundedRectangleContour(x, y, width, height, radius) {
    const r = Math.max(0, Math.min(radius, width / 2, height / 2));
    if (r <= 0.01) return makeRectangleContour(x, y, width, height);

    const points = [];
    const segments = 10;

    const addArc = (cx, cy, startAngle, endAngle) => {
      for (let i = 0; i <= segments; i++) {
        const t = i / segments;
        const angle = startAngle + (endAngle - startAngle) * t;
        points.push([
          cx + Math.cos(angle) * r,
          cy + Math.sin(angle) * r
        ]);
      }
    };

    addArc(x + width - r, y + r, -Math.PI / 2, 0);
    addArc(x + width - r, y + height - r, 0, Math.PI / 2);
    addArc(x + r, y + height - r, Math.PI / 2, Math.PI);
    addArc(x + r, y + r, Math.PI, Math.PI * 1.5);

    return closeLoop(points);
  }

  function polygonArea(points) {
    if (!points || points.length < 3) return 0;

    const loop = samePoint(points[0], points[points.length - 1])
      ? points.slice(0, -1)
      : points;

    let area = 0;
    for (let i = 0; i < loop.length; i++) {
      const current = loop[i];
      const next = loop[(i + 1) % loop.length];
      area += current[0] * next[1] - next[0] * current[1];
    }

    return Math.abs(area) / 2;
  }

  function polygonPerimeter(points) {
    if (!points || points.length < 2) return 0;

    const loop = samePoint(points[0], points[points.length - 1])
      ? points.slice(0, -1)
      : points;

    let perimeter = 0;
    for (let i = 0; i < loop.length; i++) {
      const current = loop[i];
      const next = loop[(i + 1) % loop.length];
      perimeter += Math.hypot(
        next[0] - current[0],
        next[1] - current[1]
      );
    }

    return perimeter;
  }

  function isNearlyCircularContour(points) {
    if (!points || points.length < 12) return false;

    const loop = samePoint(points[0], points[points.length - 1])
      ? points.slice(0, -1)
      : points.slice();

    const bounds = contourBounds(loop);
    const width = Math.max(1, bounds.maxX - bounds.minX);
    const height = Math.max(1, bounds.maxY - bounds.minY);
    const aspect = width / height;

    // Allow for small antialiasing and shadow-removal differences.
    if (aspect < 0.86 || aspect > 1.14) return false;

    const centreX = (bounds.minX + bounds.maxX) / 2;
    const centreY = (bounds.minY + bounds.maxY) / 2;

    const radii = loop
      .map(point => Math.hypot(
        point[0] - centreX,
        point[1] - centreY
      ))
      .filter(radius => Number.isFinite(radius) && radius > 0)
      .sort((a, b) => a - b);

    if (radii.length < 12) return false;

    // Ignore the most extreme traced pixels, which can be caused by
    // antialiasing, tiny bumps or the final contour-closing point.
    const lowIndex = Math.floor(radii.length * 0.1);
    const highIndex = Math.min(
      radii.length - 1,
      Math.ceil(radii.length * 0.9)
    );

    const lowRadius = radii[lowIndex];
    const highRadius = radii[highIndex];
    const medianRadius = radii[Math.floor(radii.length / 2)];

    if (!medianRadius) return false;

    const radialVariation =
      (highRadius - lowRadius) / medianRadius;

    // A traced circle normally remains below roughly 12–14% variation.
    // Rounded squares and irregular die-cuts have much larger radial spread.
    if (radialVariation <= 0.16) return true;

    // Secondary area test for slightly imperfect circular badges.
    const area = polygonArea(loop);
    const boundingArea = width * height;
    const fillRatio = boundingArea > 0
      ? area / boundingArea
      : 0;

    return (
      radialVariation <= 0.22 &&
      fillRatio >= 0.68 &&
      fillRatio <= 0.84
    );
  }

  function makeCircularBorderContour(points, expansionPx) {
    const bounds = contourBounds(points);
    const centreX = (bounds.minX + bounds.maxX) / 2;
    const centreY = (bounds.minY + bounds.maxY) / 2;
    const diameter = Math.max(
      bounds.maxX - bounds.minX,
      bounds.maxY - bounds.minY
    );
    const radius = diameter / 2 + Math.max(0, expansionPx);
    const output = [];

    for (let i = 0; i < 180; i++) {
      const angle = i / 180 * Math.PI * 2;
      output.push([
        centreX + Math.cos(angle) * radius,
        centreY + Math.sin(angle) * radius
      ]);
    }

    return closeLoop(output);
  }

  function drawContourFill(ctx, points, colour, smooth = true) {
    if (!points || points.length < 3) return;
    ctx.save();
    ctx.fillStyle = colour;

    if (smooth) {
      drawSmoothPath(ctx, points);
    } else {
      drawPath(ctx, points);
    }

    ctx.fill();
    ctx.restore();
  }

  function expandContourWithRoundedStroke(points, w, h, distance) {
    if (!points || points.length < 3 || distance <= 0) {
      return points ? points.slice() : [];
    }

    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const context = canvas.getContext('2d', { alpha: true, willReadFrequently: true });
    context.clearRect(0, 0, w, h);
    context.fillStyle = '#000';
    context.strokeStyle = '#000';
    context.lineWidth = distance * 2;
    context.lineJoin = 'round';
    context.lineCap = 'round';

    drawPath(context, points);
    context.fill();
    context.stroke();

    const imageData = context.getImageData(0, 0, w, h);
    const mask = new Uint8Array(w * h);
    const data = imageData.data;
    for (let p = 0; p < mask.length; p++) {
      mask[p] = data[p * 4 + 3] >= 32 ? 1 : 0;
    }

    const expanded = traceLargestContour(mask, w, h);
    return expanded.length ? expanded : points.slice();
  }

  function expandContour(points, distance) {
    if (!points || points.length < 3 || distance <= 0) {
      return points ? points.slice() : [];
    }

    const loop = samePoint(points[0], points[points.length - 1])
      ? points.slice(0, -1)
      : points.slice();

    const centre = loop.reduce(
      (sum, point) => [sum[0] + point[0], sum[1] + point[1]],
      [0, 0]
    );
    centre[0] /= loop.length;
    centre[1] /= loop.length;

    const expanded = loop.map(point => {
      const dx = point[0] - centre[0];
      const dy = point[1] - centre[1];
      const length = Math.hypot(dx, dy) || 1;
      return [
        point[0] + (dx / length) * distance,
        point[1] + (dy / length) * distance
      ];
    });

    return closeLoop(expanded);
  }

  function drawPath(ctx, points) {
    if (!points.length) return;
    ctx.beginPath();
    ctx.moveTo(points[0][0], points[0][1]);
    for (let i = 1; i < points.length; i++) ctx.lineTo(points[i][0], points[i][1]);
    ctx.closePath();
  }

  function drawSmoothPath(ctx, points) {
    if (!points || points.length < 3) {
      drawPath(ctx, points || []);
      return;
    }

    const loop = samePoint(points[0], points[points.length - 1])
      ? points.slice(0, -1)
      : points.slice();

    const firstMid = [
      (loop[0][0] + loop[1][0]) / 2,
      (loop[0][1] + loop[1][1]) / 2
    ];

    ctx.beginPath();
    ctx.moveTo(firstMid[0], firstMid[1]);

    for (let i = 1; i <= loop.length; i++) {
      const current = loop[i % loop.length];
      const next = loop[(i + 1) % loop.length];
      const midpoint = [
        (current[0] + next[0]) / 2,
        (current[1] + next[1]) / 2
      ];
      ctx.quadraticCurveTo(current[0], current[1], midpoint[0], midpoint[1]);
    }

    ctx.closePath();
  }

  function simplifyRDP(points, epsilon) {
    if (points.length < 3 || epsilon <= 0) return points;
    const closed = samePoint(points[0], points[points.length - 1]);
    const working = closed ? points.slice(0, -1) : points.slice();

    function recurse(pts) {
      if (pts.length < 3) return pts;
      let maxDistance = 0;
      let index = 0;
      for (let i = 1; i < pts.length - 1; i++) {
        const distance = perpendicularDistance(pts[i], pts[0], pts[pts.length - 1]);
        if (distance > maxDistance) {
          maxDistance = distance;
          index = i;
        }
      }
      if (maxDistance > epsilon) {
        const left = recurse(pts.slice(0, index + 1));
        const right = recurse(pts.slice(index));
        return left.slice(0, -1).concat(right);
      }
      return [pts[0], pts[pts.length - 1]];
    }

    const reduced = recurse(working);
    return closed ? closeLoop(reduced) : reduced;
  }

  function chaikin(points, iterations) {
    let result = points.slice();
    const closed = samePoint(result[0], result[result.length - 1]);
    if (closed) result.pop();

    for (let n = 0; n < iterations; n++) {
      const next = [];
      for (let i = 0; i < result.length; i++) {
        const a = result[i];
        const b = result[(i + 1) % result.length];
        next.push([a[0] * .75 + b[0] * .25, a[1] * .75 + b[1] * .25]);
        next.push([a[0] * .25 + b[0] * .75, a[1] * .25 + b[1] * .75]);
      }
      result = next;
    }

    return closed ? closeLoop(result) : result;
  }

  function simplifyContourForProduction(
    points,
    initialEpsilon,
    maximumAnchors = 200
  ) {
    if (!points || points.length <= maximumAnchors) {
      return points ? closeLoop(points) : [];
    }

    let epsilon = Math.max(0.1, initialEpsilon);
    let simplified = simplifyRDP(closeLoop(points), epsilon);

    for (
      let attempt = 0;
      attempt < 10 && simplified.length > maximumAnchors;
      attempt++
    ) {
      epsilon *= 1.28;
      simplified = simplifyRDP(closeLoop(points), epsilon);
    }

    return closeLoop(simplified);
  }

  function contourToSvgPath(
    points,
    mmPerPx,
    offsetX = 0,
    offsetY = 0,
    smooth = true
  ) {
    if (!points.length) return '';

    const loop = samePoint(points[0], points[points.length - 1])
      ? points.slice(0, -1)
      : points.slice();

    if (loop.length < 3) return '';

    const toMm = point => [
      point[0] * mmPerPx + offsetX,
      point[1] * mmPerPx + offsetY
    ];

    if (!smooth) {
      const first = toMm(loop[0]);
      let d = `M ${trimNumber(first[0])} ${trimNumber(first[1])}`;

      for (let i = 1; i < loop.length; i++) {
        const point = toMm(loop[i]);
        d += ` L ${trimNumber(point[0])} ${trimNumber(point[1])}`;
      }

      return `${d} Z`;
    }

    const first = toMm(loop[0]);
    const second = toMm(loop[1]);
    const firstMid = [
      (first[0] + second[0]) / 2,
      (first[1] + second[1]) / 2
    ];

    let d = `M ${trimNumber(firstMid[0])} ${trimNumber(firstMid[1])}`;

    for (let i = 1; i <= loop.length; i++) {
      const current = toMm(loop[i % loop.length]);
      const next = toMm(loop[(i + 1) % loop.length]);
      const midpoint = [
        (current[0] + next[0]) / 2,
        (current[1] + next[1]) / 2
      ];

      d += ` Q ${trimNumber(current[0])} ${trimNumber(current[1])} ${trimNumber(midpoint[0])} ${trimNumber(midpoint[1])}`;
    }

    return `${d} Z`;
  }

  function perpendicularDistance(point, lineStart, lineEnd) {
    const dx = lineEnd[0] - lineStart[0];
    const dy = lineEnd[1] - lineStart[1];
    if (dx === 0 && dy === 0) return Math.hypot(point[0] - lineStart[0], point[1] - lineStart[1]);
    return Math.abs(dy * point[0] - dx * point[1] + lineEnd[0] * lineStart[1] - lineEnd[1] * lineStart[0]) / Math.hypot(dx, dy);
  }

  function contourBounds(points) {
    if (!points || !points.length) {
      return { minX: 0, minY: 0, maxX: 1, maxY: 1 };
    }

    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const point of points) {
      minX = Math.min(minX, point[0]);
      minY = Math.min(minY, point[1]);
      maxX = Math.max(maxX, point[0]);
      maxY = Math.max(maxY, point[1]);
    }

    return { minX, minY, maxX, maxY };
  }

  function polygonArea(points) {
    let area = 0;
    for (let i = 0, j = points.length - 1; i < points.length; j = i++) {
      area += (points[j][0] + points[i][0]) * (points[j][1] - points[i][1]);
    }
    return area / 2;
  }

  function closeLoop(points) {
    if (!points.length) return points;
    return samePoint(points[0], points[points.length - 1]) ? points : points.concat([points[0]]);
  }

  function samePoint(a, b) {
    return a && b && a[0] === b[0] && a[1] === b[1];
  }

  function hexToRgb(hex) {
    const clean = normaliseHex(hex).slice(1);
    return {
      r: parseInt(clean.slice(0,2), 16),
      g: parseInt(clean.slice(2,4), 16),
      b: parseInt(clean.slice(4,6), 16)
    };
  }

  function normaliseHex(hex) {
    if (/^#[0-9a-f]{6}$/i.test(hex)) return hex;
    return '#ffffff';
  }

  function canvasToBlob(canvas, type) {
    return new Promise(resolve => canvas.toBlob(resolve, type, 1));
  }

  function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }

  function trimNumber(value) {
    return Number(Number(value).toFixed(3)).toString();
  }

  function baseName(filename) {
    return filename.replace(/\.[^.]+$/, '').replace(/[^a-z0-9-_]+/gi, '-').replace(/^-|-$/g, '') || 'sticker';
  }

  function titleCase(value) {
    return value.replace(/-/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase());
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }
})();
